/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Admin API (placeholder)
 * Committed placeholder spec. `bun run sync-spec` replaces this file from OPENAPI_SPEC_URL. Codegen always reads the committed file so builds are reproducible offline and contract changes show up as reviewable diffs.
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  faker
} from '@faker-js/faker';

import {
  HttpResponse,
  http
} from 'msw';
import type {
  RequestHandlerOptions
} from 'msw';

import { apiMutator } from '../../http/mutator';
export type ProblemErrors = {[key: string]: string[]};

/**
 * RFC 7807-shaped error. Assumed shape — re-verify against the live API; toAppError is the single place that has to change.
 */
export interface Problem {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  code?: string;
  traceId?: string;
  errors?: ProblemErrors;
}

export interface LoginRequest {
  email: string;
  /** @minLength 8 */
  password: string;
}

export interface RefreshRequest {
  refreshToken: string;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  /** Access token lifetime in seconds */
  expiresIn: number;
}

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];


export const UserStatus = {
  active: 'active',
  invited: 'invited',
  suspended: 'suspended',
} as const;

export interface SessionUser {
  id: string;
  email: string;
  displayName: string;
  tenantId?: string;
  roles: string[];
  permissions?: string[];
}

export interface User {
  id: string;
  email: string;
  displayName: string;
  status: UserStatus;
  /** Account manager. Drives the PBAC condition in Phase 6/7. */
  ownerId: string;
  tenantId?: string;
  createdAt: string;
}

export interface UpdateUserRequest {
  /** @minLength 1 */
  displayName?: string;
  status?: UserStatus;
}

export interface UserPage {
  items: User[];
  page: number;
  pageSize: number;
  total: number;
}

/**
 * The device lifecycle state, rendered as sent. ABSENT for a device with no state yet, which the portal renders as a dash.
 */
export type DeviceRecordState = typeof DeviceRecordState[keyof typeof DeviceRecordState];


export const DeviceRecordState = {
  INVENTORY: 'INVENTORY',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  RELEASED: 'RELEASED',
} as const;

/**
 * Accompanies LOCKED only; absent for every other posture.
 */
export type DeviceRecordLockMode = typeof DeviceRecordLockMode[keyof typeof DeviceRecordLockMode];


export const DeviceRecordLockMode = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
} as const;

export type DeviceRecordAllowedActionsItem = typeof DeviceRecordAllowedActionsItem[keyof typeof DeviceRecordAllowedActionsItem];


export const DeviceRecordAllowedActionsItem = {
  ENROL: 'ENROL',
  UNENROL: 'UNENROL',
  MESSAGE: 'MESSAGE',
  LOCK: 'LOCK',
  RELEASE: 'RELEASE',
  UNLOCK: 'UNLOCK',
} as const;

/**
 * What the command asks the device to do. LOCK and UNLOCK are issuable today; RELEASE arrives later.
 */
export type LastCommandAction = typeof LastCommandAction[keyof typeof LastCommandAction];


export const LastCommandAction = {
  LOCK: 'LOCK',
  UNLOCK: 'UNLOCK',
  RELEASE: 'RELEASE',
} as const;

/**
 * The REQUESTED mode, present for a LOCK and absent for every other action. Distinct from the record's top-level `lock_mode`, which is the OBSERVED mode and appears only once the device has acknowledged — while a lock is in flight the two legitimately disagree.
 */
export type LastCommandLockMode = typeof LastCommandLockMode[keyof typeof LastCommandLockMode];


export const LastCommandLockMode = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
} as const;

/**
 * The command lifecycle vocabulary, published whole so a later widening is not a breaking change. Only QUEUED, SENT and ACKED are producible in this row today: EXPIRED and SUPERSEDED are written only into history, and FAILED and PENDING_AGENT have no writer. Treat an unrecognised value defensively rather than switching exhaustively.
 */
export type LastCommandStatus = typeof LastCommandStatus[keyof typeof LastCommandStatus];


export const LastCommandStatus = {
  QUEUED: 'QUEUED',
  SENT: 'SENT',
  PENDING_AGENT: 'PENDING_AGENT',
  ACKED: 'ACKED',
  FAILED: 'FAILED',
  EXPIRED: 'EXPIRED',
  SUPERSEDED: 'SUPERSEDED',
} as const;

/**
 * The newest command issued against a device, whatever its status — the same shape on the list and detail surfaces, so one renderer serves both. Absent for a device never commanded. This is not the device's posture: `state` is. Deriving pending and expired is the client's job — in flight is any `status` but ACKED with `expires_at` in the future, expired is any `status` but ACKED with `expires_at` already past. ACKED is the acknowledgement the device itself sends and the only status that ends an attempt; nothing else the platform records closes one on its own, so a status added to this enum later reads as still being attempted rather than as settled. Nothing sweeps the row, so an unacknowledged command keeps its pending status past its window and `expires_at` is the only honest signal — under this rule it is the only thing that ends the attempt at all.
 */
export interface LastCommand {
  /** Correlation id — the value the issuing call answered with, so a client can match its own 202 to the command it sees here on the next refresh. */
  command_id: string;
  /** What the command asks the device to do. LOCK and UNLOCK are issuable today; RELEASE arrives later. */
  action: LastCommandAction;
  /** The REQUESTED mode, present for a LOCK and absent for every other action. Distinct from the record's top-level `lock_mode`, which is the OBSERVED mode and appears only once the device has acknowledged — while a lock is in flight the two legitimately disagree. */
  lock_mode?: LastCommandLockMode;
  /** The command lifecycle vocabulary, published whole so a later widening is not a breaking change. Only QUEUED, SENT and ACKED are producible in this row today: EXPIRED and SUPERSEDED are written only into history, and FAILED and PENDING_AGENT have no writer. Treat an unrecognised value defensively rather than switching exhaustively. */
  status: LastCommandStatus;
  /** When the platform recorded the intent — the age an operator watching a pending command is actually judging. */
  issued_at: string;
  /** The deadline after which the command no longer fences a re-issue and is no longer served to the device. A deadline, not an event: no row is stamped at the moment it expires, so a client detects the expired case by comparing this to now. */
  expires_at: string;
}

/**
 * `dfpost` Device Financing Post-paid (the only one enabled), `sc` Supply Chain, `dfpre` DF Pre-paid, `sim` SIM Control.
 */
export type EnrolmentService = typeof EnrolmentService[keyof typeof EnrolmentService];


export const EnrolmentService = {
  dfpost: 'dfpost',
  sc: 'sc',
  dfpre: 'dfpre',
  sim: 'sim',
} as const;

/**
 * One item of GET /v1/devices — the minimal registration fields plus the enforcement state the STATE column renders. A queued lock leaves `state` at its committed value and is carried separately as `last_command`, so the client renders a pending command alongside the posture, never instead of it.
 */
export interface DeviceRecord {
  device_id: string;
  /**
     * Present only when the device was registered by IMEI. Exactly one of imei/serial is present on a record; the other property is absent.
     * @pattern ^[0-9]{15}$
     */
  imei?: string;
  /** Present only when the device was registered by serial. Exactly one of imei/serial is present on a record; the other property is absent. */
  serial?: string;
  /** Registration timestamp, ISO 8601 with microsecond precision. Observed on every record. This is what 'newest first' orders by, and it is the only date the list surface carries. */
  created_at: string;
  /** The device lifecycle state, rendered as sent. ABSENT for a device with no state yet, which the portal renders as a dash. */
  state?: DeviceRecordState;
  /** Accompanies LOCKED only; absent for every other posture. */
  lock_mode?: DeviceRecordLockMode;
  last_command?: LastCommand;
  /** The actions the platform accepts for this device right now. OMITTED is the same as empty: nothing is offered. */
  allowed_actions?: DeviceRecordAllowedActionsItem[];
  /** The service of the device's most recently created LIVE enrolment (CEN-1675) — the SERVICE column. Closed enrolments are ignored. OMITTED for a device with no live enrolment, and the portal renders a dash. */
  service?: EnrolmentService;
}

/**
 * The device lifecycle state, rendered as sent. ABSENT for a device with no state yet, which the portal renders as a dash.
 */
export type DeviceDetailRecordState = typeof DeviceDetailRecordState[keyof typeof DeviceDetailRecordState];


export const DeviceDetailRecordState = {
  INVENTORY: 'INVENTORY',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  RELEASED: 'RELEASED',
} as const;

/**
 * Accompanies LOCKED only; absent for every other posture.
 */
export type DeviceDetailRecordLockMode = typeof DeviceDetailRecordLockMode[keyof typeof DeviceDetailRecordLockMode];


export const DeviceDetailRecordLockMode = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
} as const;

export type DeviceDetailRecordAllowedActionsItem = typeof DeviceDetailRecordAllowedActionsItem[keyof typeof DeviceDetailRecordAllowedActionsItem];


export const DeviceDetailRecordAllowedActionsItem = {
  ENROL: 'ENROL',
  UNENROL: 'UNENROL',
  MESSAGE: 'MESSAGE',
  LOCK: 'LOCK',
  RELEASE: 'RELEASE',
  UNLOCK: 'UNLOCK',
} as const;

/**
 * UNPROVISIONED: registered but never checked in, and `last_seen_at` is absent with it. ONLINE: checked in within the heartbeat window. OFFLINE: has checked in before, but not within it. Computed on read from `last_seen_at`, never stored.
 */
export type DeviceDetailRecordConnectivityStatus = typeof DeviceDetailRecordConnectivityStatus[keyof typeof DeviceDetailRecordConnectivityStatus];


export const DeviceDetailRecordConnectivityStatus = {
  UNPROVISIONED: 'UNPROVISIONED',
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
} as const;

/**
 * Hardware facts the agent reads off the build. Absent as a whole until the device first reports, and open-ended: unknown members are ignored by the client.
 * @nullable
 */
export type DeviceDetailRecordDeviceProperties = {
  /**
     * SoC board name, e.g. `kalama`.
     * @nullable
     */
  board?: string | null;
  /**
     * Consumer brand the build declares, e.g. `samsung`. Lowercase as sent.
     * @nullable
     */
  brand?: string | null;
  /**
     * Hardware platform, e.g. `qcom`.
     * @nullable
     */
  hardware?: string | null;
  /**
     * OEM as the build declares it, e.g. `Samsung`.
     * @nullable
     */
  manufacturer?: string | null;
  /**
     * Installed RAM in megabytes.
     * @nullable
     */
  ram_mb?: number | null;
  /**
     * Total storage in gigabytes. Capacity, not usage — nothing here reports how full the device is.
     * @nullable
     */
  storage_gb?: number | null;
} | null;

/**
 * Firmware and OS build facts, reported alongside the hardware ones and absent for the same reason. Open-ended: unknown members are ignored by the client.
 * @nullable
 */
export type DeviceDetailRecordDeviceVersionProperties = {
  /**
     * Android API level, e.g. 34. Pairs with `android_version` — the release name for the same build.
     * @nullable
     */
  sdk_int?: number | null;
  /**
     * OS build id, e.g. `UP1A.231005.007`.
     * @nullable
     */
  build_id?: string | null;
  /**
     * Bootloader version string.
     * @nullable
     */
  bootloader?: string | null;
  /**
     * Kernel release, e.g. `5.15.94-android13`.
     * @nullable
     */
  kernel_version?: string | null;
  /**
     * Security patch level, an ISO date (`2025-06-01`), not a timestamp.
     * @nullable
     */
  security_patch?: string | null;
} | null;

export type EnrolmentState = typeof EnrolmentState[keyof typeof EnrolmentState];


export const EnrolmentState = {
  INVENTORY: 'INVENTORY',
  PROTECTED: 'PROTECTED',
  ENROLLED: 'ENROLLED',
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  TIMED: 'TIMED',
  PARTIAL: 'PARTIAL',
  APP_RESTRICTION: 'APP_RESTRICTION',
  CALL_RESTRICTION: 'CALL_RESTRICTION',
  FULL_RESTRICTION: 'FULL_RESTRICTION',
  THEFT: 'THEFT',
  REPAIR: 'REPAIR',
  RELEASED: 'RELEASED',
} as const;

export interface DeviceEnrolment {
  enrolment_id: string;
  service: EnrolmentService;
  state: EnrolmentState;
  entered_at: string;
  closed: boolean;
  /** @nullable */
  plan_id: string | null;
  /** @nullable */
  workflow_version: string | null;
}

/**
 * One device in full. `device_id`, `created_at` and `connectivity_status` are always present, and at least one of `imei` / `serial`; the posture members follow the same rules as on the list surface. Everything past them is agent-reported and absent until the device checks in.
 */
export interface DeviceDetailRecord {
  device_id: string;
  /**
     * Present only when the device was registered by IMEI. Sensitive: never log this value.
     * @nullable
     * @pattern ^[0-9]{15}$
     */
  imei?: string | null;
  /**
     * Present only when the device was registered by serial. Sensitive: never log this value.
     * @nullable
     */
  serial?: string | null;
  /** Registration timestamp, ISO 8601 with microsecond precision. When the device entered the registry, not when it enrolled. */
  created_at: string;
  /** The device lifecycle state, rendered as sent. ABSENT for a device with no state yet, which the portal renders as a dash. */
  state?: DeviceDetailRecordState;
  /** Accompanies LOCKED only; absent for every other posture. */
  lock_mode?: DeviceDetailRecordLockMode;
  last_command?: LastCommand;
  /** The actions the platform accepts for this device right now. OMITTED is the same as empty: nothing is offered. */
  allowed_actions?: DeviceDetailRecordAllowedActionsItem[];
  /** UNPROVISIONED: registered but never checked in, and `last_seen_at` is absent with it. ONLINE: checked in within the heartbeat window. OFFLINE: has checked in before, but not within it. Computed on read from `last_seen_at`, never stored. */
  connectivity_status: DeviceDetailRecordConnectivityStatus;
  /**
     * Last agent check-in, ISO 8601. Null until the device has ever checked in.
     * @nullable
     */
  last_seen_at?: string | null;
  /**
     * The Android ID (SSAID) the agent reports. Sensitive: a stable per-device identifier.
     * @nullable
     */
  android_id?: string | null;
  /**
     * Android release name, e.g. `14`. A string, not a number: releases like `12L` exist.
     * @nullable
     */
  android_version?: string | null;
  /**
     * Marketing model name, e.g. `Galaxy S23`.
     * @nullable
     */
  device_model_name?: string | null;
  /**
     * Model code as the build declares it, e.g. `SM-S911B`.
     * @nullable
     */
  device_model_id?: string | null;
  /**
     * Hardware facts the agent reads off the build. Absent as a whole until the device first reports, and open-ended: unknown members are ignored by the client.
     * @nullable
     */
  device_properties?: DeviceDetailRecordDeviceProperties;
  /**
     * Firmware and OS build facts, reported alongside the hardware ones and absent for the same reason. Open-ended: unknown members are ignored by the client.
     * @nullable
     */
  device_version_properties?: DeviceDetailRecordDeviceVersionProperties;
  /**
     * Android user serial number (`0` for the primary user). A multi-user handle, not the hardware serial — that is `serial`.
     * @nullable
     */
  user_serial?: string | null;
  /** Every enrolment the device has carried, closed ones included; always present, empty when none. */
  enrolments: DeviceEnrolment[];
}

/**
 * The window the server actually served, plus the size of the whole result set.
 */
export interface DevicePagination {
  /** 1-based number of the page returned. */
  page: number;
  /** Page size the server applied; it may differ from the one requested. */
  limit: number;
  /** Devices matching the filters across every page. */
  total: number;
  /** Number of pages at this limit. 0 when total is 0. */
  total_pages: number;
}

/**
 * Newest first by created_at. `pagination` describes the window served and the size of the whole result set. An empty devices array is a valid answer, never a 404.
 */
export interface DeviceList {
  devices: DeviceRecord[];
  pagination: DevicePagination;
}

/**
 * Registration payload for POST /v1/devices. IMEI only — the serial identifier is not registerable on this surface.
 */
export interface RegisterDeviceRequest {
  /**
     * 15-digit IMEI. The pattern is the syntactic half of PC-REG-01's check (400 on violation); the Luhn check digit is semantic and enforced in the service (422, violation code imei_luhn_failed). SENSITIVE (Obs §2.1, 4 Aug 2026): never emitted raw in logs, spans, metrics, or error bodies — a validation error names the field and code, never the value.
     * @pattern ^[0-9]{15}$
     */
  imei: string;
}

/**
 * The accepted command. Not a posture: `state` is unchanged by this call and moves only when the device acknowledges. `last_command` is returned whole so a client can render the pending row without a second request.
 */
export interface LockDeviceResponse {
  /** Correlation id — the same value that appears as `last_command.command_id`, so a client can match its own response to the command it sees on the next refresh. */
  command_id: string;
  last_command: LastCommand;
}

/**
 * The accepted command, on the same terms as `LockDeviceResponse`. Not a posture: `state` is unchanged by this call and moves only when the device acknowledges. `last_command` is returned whole so a client can render the pending row without a second request.
 */
export interface UnlockDeviceResponse {
  /** Correlation id — the same value that appears as `last_command.command_id`, so a client can match its own response to the command it sees on the next refresh. */
  command_id: string;
  last_command: LastCommand;
}

/**
 * PENDING is invited and not yet through a first password change; ACTIVE has been through one; DEACTIVATED is a soft delete — the record persists for the audit trail.
 */
export type IdentityUserStatus = typeof IdentityUserStatus[keyof typeof IdentityUserStatus];


export const IdentityUserStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
} as const;

/**
 * A role a user holds, drawn from two domains. A user may hold several. SUPER_ADMIN and INTERNAL_DATA_LOADER are internal-domain roles, held by platform staff and never granted from a tenant's own screens; the remaining seven are tenant-domain roles. The portal keeps a copy description of each (name, permissions, reach) and renders one beside each role the user holds, and it lists every role when narrowing but offers only the tenant-domain ones when inviting.
 */
export type IdentityUserRole = typeof IdentityUserRole[keyof typeof IdentityUserRole];


export const IdentityUserRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  INTERNAL_DATA_LOADER: 'INTERNAL_DATA_LOADER',
  TENANT_ADMIN: 'TENANT_ADMIN',
  OPERATIONS: 'OPERATIONS',
  PROVISIONING: 'PROVISIONING',
  FINANCE: 'FINANCE',
  SUPPORT: 'SUPPORT',
  VIEWER: 'VIEWER',
  RELEASE_AUTHORITY: 'RELEASE_AUTHORITY',
} as const;

/**
 * A tenant user. Named apart from the placeholder User schema on /users, which is a different contract with camelCase keys and lowercase statuses; the two must not be merged by name.
 */
export interface IdentityUser {
  id: string;
  name: string;
  email: string;
  /** Every role the user holds, in the order the platform returns them. May be empty for a user who holds none. */
  roles: IdentityUserRole[];
  status: IdentityUserStatus;
  created_at: string;
  updated_at: string;
  /**
     * When the user was last reactivated after a deactivation. Absent or null for a user who has never been reactivated.
     * @nullable
     */
  reactivated_at?: string | null;
  /**
     * Present only on a DEACTIVATED user.
     * @nullable
     */
  deactivated_at?: string | null;
  /**
     * When the user's pending invitation lapses. Set on a PENDING user; absent or null otherwise.
     * @nullable
     */
  invite_expires_at?: string | null;
}

/**
 * The window the server actually served, plus the size of the whole result set.
 */
export interface IdentityUserPagination {
  /** 1-based number of the page returned. */
  page: number;
  /** Page size the server applied; it may differ from the one requested. */
  limit: number;
  /** Users matching the filters across every page. */
  total: number;
  /** Number of pages at this limit. 0 when total is 0. */
  total_pages: number;
}

/**
 * An empty data array is a valid answer, never a 404.
 */
export interface IdentityUserList {
  data: IdentityUser[];
  pagination: IdentityUserPagination;
}

/**
 * Both lengths are the design's field caps carried onto the wire, not a platform limit anyone has stated.
 */
export interface InviteUserRequest {
  /**
     * @minLength 1
     * @maxLength 128
     */
  name: string;
  /**
     * Unique per tenant; a duplicate answers 409 USER_ALREADY_EXISTS.
     * @maxLength 128
     */
  email: string;
  /** A tenant-domain role. Omit to take the platform's default of VIEWER; the internal-domain roles are not invitable from a tenant. */
  role?: IdentityUserRole;
}

export interface InviteUserResponse {
  user: IdentityUser;
}

/**
 * One user, wrapped the way InviteUserResponse wraps the created one, so the two identity write surfaces answer in the same shape.
 */
export interface IdentityUserResponse {
  user: IdentityUser;
}

/**
 * The GET /v1/identity/users/{id} 200 body: one user of the caller's own tenant, wrapped as `{user}`, plus `permissions`.
 */
export interface GetIdentityUserResponse {
  user: IdentityUser;
  /**
     * Every permission string (`<resource>.<action>`) the user's `roles` grant under the tenant's role definitions, deduplicated and sorted. The same set the tenant edge authorizer grants: a role the tenant defines as not assignable, or one held without a base role it requires, grants nothing. Empty when the roles grant nothing.
     * @items.minLength 1
     */
  permissions: string[];
}

/**
 * Which side of the platform a role is held on. An internal-domain role belongs to platform staff and reaches across tenants; a tenant-domain role is held inside one tenant and reaches no further. Lowercase here, unlike the other role enums, because it names a part of the platform rather than a value the caller sends back.
 */
export type RoleDomain = typeof RoleDomain[keyof typeof RoleDomain];


export const RoleDomain = {
  tenant: 'tenant',
  internal: 'internal',
} as const;

/**
 * What the role lets a holder do, written for a tenant admin reading the list. Either one line of prose, or the same answer grouped by the area it reaches: each key names an area and its array names the actions the role carries there. An area whose array is empty is one the role does not reach.
 */
export type RoleRecordSummary = string | {[key: string]: string[]};

export type RoleRecordUsersSampleItem = {
  id: string;
  name: string;
  email: string;
};

/**
 * The users currently holding this role: how many hold it in all, and enough of them to name. Present for a role nobody holds too, as a total of 0 and an empty sample.
 */
export type RoleRecordUsers = {
  /** Holders of this role across the tenant — the number to count against, not the sample's length. */
  total: number;
  /** The first holders, in the platform's order, carrying only what it takes to name one. Shorter than total when more hold the role than the platform samples. */
  sample: RoleRecordUsersSampleItem[];
};

/**
 * One role, and everyone currently holding it. Flat rather than composed from a smaller option shape, matching the rest of this spec: value, label and domain are the three fields a role picker would need, and the rest describe the role in full. `value` is an IdentityUserRole rather than a free identifier: the platform's roles are fixed and a tenant cannot define its own, so every role this list returns is one that enum names — which is what lets `summary` and `grantable_by` speak in that enum. `users` is a count with a sample rather than the whole roster: the list names a couple of holders and says how many more there are, and a role can be held by more users than a list row would ever show.
 */
export interface RoleRecord {
  value: IdentityUserRole;
  /** The role's display name, in the platform's own English. Not localised — a portal that translates role names uses value to look its own copy up. */
  label: string;
  domain: RoleDomain;
  /** Every area an assignment of the role reaches, each named in the platform’s own English and ready to show as it arrives — "One device", "Tenant-wide *". A role that reaches several areas names each of them, and where a name carries a marker such as an asterisk or a dagger the marker is part of that name rather than a field of its own. Empty means the platform states no reach for the role. Free text rather than an enum: reach is a sentence the platform writes about a role, and a role the platform gains can state a reach no enum was written for. */
  scope: string[];
  /** True for the role an invitation takes when it names none. */
  is_default: boolean;
  /** Whether this role may be granted to a user at all. A false value does not say the caller may grant it — grantable_by does. */
  assignable: boolean;
  /** Every permission the role carries, as dotted identifiers. Order is the platform's and carries no meaning. */
  permissions: string[];
  /** What the role lets a holder do, written for a tenant admin reading the list. Either one line of prose, or the same answer grouped by the area it reaches: each key names an area and its array names the actions the role carries there. An area whose array is empty is one the role does not reach. */
  summary: RoleRecordSummary;
  /** The roles that may hand this one out, by value. Empty means no role can, which is how a role the platform assigns itself is described. */
  grantable_by: IdentityUserRole[];
  /** The users currently holding this role: how many hold it in all, and enough of them to name. Present for a role nobody holds too, as a total of 0 and an empty sample. */
  users: RoleRecordUsers;
  /**
     * A limit worth stating beside the summary, such as a capability the role notably does not carry. Absent when there is nothing to warn about.
     * @nullable
     */
  caveat?: string | null;
}

/**
 * The window the server actually served, plus the size of the whole set.
 */
export interface RolePagination {
  /** 1-based number of the page returned. */
  page: number;
  /** Page size the server applied; it may differ from the one requested. */
  limit: number;
  /** Roles across every page. */
  total: number;
  /** Number of pages at this limit. 0 when total is 0. */
  total_pages: number;
}

/**
 * An empty data array is a valid answer, never a 404.
 */
export interface RoleList {
  data: RoleRecord[];
  pagination: RolePagination;
}

/**
 * PROPOSED (CEN-1299). Opens a bulk-registration job. Describes the file about to be uploaded so the backend can mint a scoped upload ticket and pre-check the header; the bytes are sent to the ticket URL, not in this body. The client pre-checks size against the documented ceiling before calling: max_size_bytes is the server's own limit and a violation answers 413 file_too_large.
 */
export interface CreateBulkRegistrationRequest {
  /** Original file name, for display and the audit trail. Not a path. */
  file_name: string;
  /** Byte length of the CSV, for the server's size check and the client's pre-check against the published ceiling (1M-row sanity bound, ~40-60 MB). */
  size_bytes: number;
  /** MUST be text/csv. Any other value answers 415. */
  content_type: string;
}

/**
 * Always PUT for the direct-to-storage upload.
 */
export type BulkUploadTicketMethod = typeof BulkUploadTicketMethod[keyof typeof BulkUploadTicketMethod];


export const BulkUploadTicketMethod = {
  PUT: 'PUT',
} as const;

/**
 * Headers to send verbatim on the PUT (e.g. Content-Type). Omitted when none are required.
 */
export type BulkUploadTicketHeaders = {[key: string]: string};

/**
 * PROPOSED (CEN-1299). Presigned instructions for uploading the CSV directly to storage. The client PUTs the raw file to `url` with `method` and `headers` verbatim, outside the API client — no bearer token, no 401 replay, no 30s timeout. Present only while the job is `awaiting_upload`.
 */
export interface BulkUploadTicket {
  /** Presigned URL to PUT the raw CSV to. Short-lived (see expires_at). */
  url: string;
  /** Always PUT for the direct-to-storage upload. */
  method: BulkUploadTicketMethod;
  /** Headers to send verbatim on the PUT (e.g. Content-Type). Omitted when none are required. */
  headers?: BulkUploadTicketHeaders;
  /** When the ticket stops accepting the upload. Kept generous (>= 1h) so a slow large upload does not expire mid-flight. */
  expires_at: string;
}

/**
 * PROPOSED (CEN-1299). Closed job lifecycle vocabulary. Clients treat an unrecognised value as `processing` (a non-terminal fallback) rather than crashing. `completed` = all rows registered; `completed_with_rejections` = finished, some rows rejected (fixable); `needs_attention` = at least one batch FAILED and its rows are unprocessed, not rejected — the state whose primary action is retry; `failed` = the job as a whole could not run; `expired` = the upload ticket lapsed before start.
 */
export type BulkRegistrationStatus = typeof BulkRegistrationStatus[keyof typeof BulkRegistrationStatus];


export const BulkRegistrationStatus = {
  awaiting_upload: 'awaiting_upload',
  queued: 'queued',
  processing: 'processing',
  completed: 'completed',
  completed_with_rejections: 'completed_with_rejections',
  needs_attention: 'needs_attention',
  failed: 'failed',
  expired: 'expired',
} as const;

/**
 * PROPOSED (CEN-1299). Per-batch lifecycle. `failed` is an infrastructure fault whose rows are unprocessed (retryable), distinct from rows the batch processed and rejected.
 */
export type BulkRegistrationBatchStatus = typeof BulkRegistrationBatchStatus[keyof typeof BulkRegistrationBatchStatus];


export const BulkRegistrationBatchStatus = {
  pending: 'pending',
  processing: 'processing',
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

/**
 * PROPOSED (CEN-1299). Closed set of row-rejection reasons (PC-REG-02/03/04). Duplicates are their own reasons, never format errors. Tie-break: the first occurrence of an identifier in file order wins; later same-identifier rows are `duplicate_in_file` (the backend must dedupe across batches before partitioning). `duplicate_identifier_conflict` = an IMEI paired with a different serial than an existing record. Clients map each code to a localized message with an `other` fallback so an unknown code still renders.
 */
export type BulkRejectionReason = typeof BulkRejectionReason[keyof typeof BulkRejectionReason];


export const BulkRejectionReason = {
  missing_identifier: 'missing_identifier',
  imei_format: 'imei_format',
  imei_luhn: 'imei_luhn',
  imei2_format: 'imei2_format',
  imei2_luhn: 'imei2_luhn',
  serial_format: 'serial_format',
  duplicate_in_file: 'duplicate_in_file',
  duplicate_existing: 'duplicate_existing',
  duplicate_identifier_conflict: 'duplicate_identifier_conflict',
} as const;

/**
 * PROPOSED (CEN-1299). One 10,000-row partition of the file, processed independently so a failure isolates.
 */
export interface BulkRegistrationBatch {
  /** Zero-based position of the batch within the job. */
  index: number;
  /** 1-based first data row (excluding the header) this batch covers. */
  row_from: number;
  /** 1-based last data row this batch covers, inclusive. */
  row_to: number;
  status: BulkRegistrationBatchStatus;
  /** Rows in this batch registered so far. */
  registered: number;
  /** Rows in this batch rejected with a reason. Zero while the batch is pending/processing or when it failed before processing any row. */
  rejected: number;
}

/**
 * The uploaded file's descriptor. `row_count` is null until the file is parsed.
 */
export type BulkRegistrationFile = {
  name: string;
  size_bytes: number;
  /**
     * Data rows excluding the header. Null until parsed.
     * @nullable
     */
  row_count?: number | null;
};

/**
 * Job-wide roll-up. `unprocessed` counts rows in failed batches that were never processed — distinct from `rejected`. rows = registered + rejected + unprocessed once terminal.
 */
export type BulkRegistrationTotals = {
  rows: number;
  registered: number;
  rejected: number;
  unprocessed: number;
};

/**
 * Counts of rejected rows keyed by BulkRejectionReason. Counts only — never row values.
 */
export type BulkRegistrationRejectionBreakdown = {[key: string]: number};

/**
 * Availability of the consolidated results CSV, fetched from .../results.
 */
export type BulkRegistrationResults = {
  /** True once the results file exists (job terminal with rejections). */
  available: boolean;
};

/**
 * PROPOSED (CEN-1299). An async bulk device-registration job (PC-REG-02). Carries overall and per-batch progress and a three-way outcome: registered / rejected (bad rows to fix) / unprocessed (rows in a failed batch never looked at). Row values are never here — only counts; the rejected rows are in the results CSV. Tenant-scoped; 404 across tenants.
 */
export interface BulkRegistration {
  /** The job's UUIDv7. Not sensitive; safe in a URL (the UI keeps it in `?import=`). */
  id: string;
  status: BulkRegistrationStatus;
  /** When the job was opened. */
  created_at: string;
  /** Actor id that opened the job, for the audit trail. */
  created_by: string;
  /** When processing began. Absent until the job is started. */
  started_at?: string;
  /** When the job reached a terminal status. Absent until then. */
  completed_at?: string;
  /** The uploaded file's descriptor. `row_count` is null until the file is parsed. */
  file: BulkRegistrationFile;
  /** Rows per processing batch. 10000 per PC-REG-02. */
  batch_size: number;
  /** Per-batch progress. Empty until the file is partitioned. */
  batches: BulkRegistrationBatch[];
  /** Job-wide roll-up. `unprocessed` counts rows in failed batches that were never processed — distinct from `rejected`. rows = registered + rejected + unprocessed once terminal. */
  totals: BulkRegistrationTotals;
  /** Counts of rejected rows keyed by BulkRejectionReason. Counts only — never row values. */
  rejection_breakdown: BulkRegistrationRejectionBreakdown;
  upload?: BulkUploadTicket;
  /** Availability of the consolidated results CSV, fetched from .../results. */
  results: BulkRegistrationResults;
}

export interface CreateEnrolmentRequest {
  /**
     * The IMEI the device was registered with. Sensitive: never log this value.
     * @pattern ^[0-9]{15}$
     */
  imei: string;
  service: EnrolmentService;
  /** @nullable */
  plan_id?: string | null;
  /** @nullable */
  workflow_version?: string | null;
}

export interface EnrolmentRecord {
  enrolment_id: string;
  device_id: string;
  service: EnrolmentService;
  state: EnrolmentState;
  entered_at: string;
  /** @nullable */
  plan_id: string | null;
  /** @nullable */
  workflow_version: string | null;
  correlation_id: string;
}

/**
 * @pattern ^#[0-9a-fA-F]{6}$
 */
export type TenantBrandingHex = string;

export type TenantBrandingLogoMediaType = typeof TenantBrandingLogoMediaType[keyof typeof TenantBrandingLogoMediaType];


export const TenantBrandingLogoMediaType = {
  'image/png': 'image/png',
  'image/svg+xml': 'image/svg+xml',
} as const;

/**
 * One logo file: PNG or SVG, base64 in data. The length bound is on the encoded text (a 1 MB file is about 1.4 million characters); the 1 MB rule itself is the service's.
 */
export interface TenantBrandingLogo {
  media_type: TenantBrandingLogoMediaType;
  /**
     * @minLength 1
     * @maxLength 1420000
     */
  data: string;
}

/**
 * signature keeps the platform's neutral primary colour; branded paints the tenant's own primary.
 */
export type TenantBrandingTheme = typeof TenantBrandingTheme[keyof typeof TenantBrandingTheme];


export const TenantBrandingTheme = {
  signature: 'signature',
  branded: 'branded',
} as const;

/**
 * The tenant palette. All four are always sent, whatever the theme.
 */
export interface TenantBrandingColors {
  primary: TenantBrandingHex;
  secondary: TenantBrandingHex;
  accent: TenantBrandingHex;
  surface: TenantBrandingHex;
}

export interface TenantBrandingCurrency {
  /**
     * ISO 4217 alphabetic code.
     * @pattern ^[A-Z]{3}$
     */
  code: string;
  /**
     * What the device prints beside an amount.
     * @minLength 1
     * @maxLength 5
     */
  symbol: string;
}

/**
 * The WHOLE branding set a Tenant Admin publishes for the device-holder surfaces. Full replace: leaving out `logo_full` removes the tenant's full logo.
 */
export interface TenantBrandingRequest {
  /**
     * The tenant name the holder surfaces show where the logo cannot.
     * @minLength 1
     * @maxLength 32
     */
  display_name: string;
  logo_icon: TenantBrandingLogo;
  logo_full?: TenantBrandingLogo;
  theme: TenantBrandingTheme;
  colors: TenantBrandingColors;
  currency: TenantBrandingCurrency;
}

/**
 * The branding set in force. The logos come from the tenant's asset bundle; theme, colours and currency come from the tenant record once a publish has written them, and from the bundle before that.
 */
export interface TenantBrandingResponse {
  /**
     * The tenant name the holder surfaces show where the logo cannot.
     * @minLength 1
     * @maxLength 32
     */
  display_name: string;
  logo_icon: TenantBrandingLogo;
  logo_full: TenantBrandingLogo;
  theme: TenantBrandingTheme;
  colors: TenantBrandingColors;
  currency: TenantBrandingCurrency;
  /**
     * The published bundle version devices compare against. One higher after every successful publish.
     * @minimum 1
     */
  assets_version: number;
}

export interface TenantWhitelistSummary {
  /**
     * @minLength 1
     * @maxLength 64
     */
  id: string;
  /**
     * @minLength 1
     * @maxLength 64
     * @pattern ^(?=.*\S)[^\u0000-\u001f\u007f\u0085\u2028\u2029]+$
     */
  name: string;
  /** Exactly one list carries true once the tenant has any. */
  is_default: boolean;
  /** @minimum 1 */
  version: number;
}

/**
 * Every list the tenant holds, without their entries. Returned whole: a tenant holds at most 50 lists (create refuses the 51st), so the portal paginates the table itself. An empty array is a tenant with no list yet. No workflow or device count is carried yet: workflows do not exist in the backend.
 */
export interface TenantWhitelistsResponse {
  /** @maxItems 50 */
  whitelists: TenantWhitelistSummary[];
}

/**
 * Error
 */
export type ProblemResponse = Problem;

export type ListUsersParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
pageSize?: number;
q?: string;
sort?: string;
status?: UserStatus;
};

export type ListDevicesParams = {
/**
 * Exact-match device identifier — an IMEI or a serial. Sensitive: never log this value.
 */
identifier?: string;
/**
 * 1-based page number. A page past the last one answers an empty devices array, never a 404.
 * @minimum 1
 */
page?: number;
/**
 * Page size.
 * @minimum 1
 * @maximum 200
 */
limit?: number;
};

export type ListIdentityUsersParams = {
/**
 * Matches a user by name or email. Unvalidated: a value matching nothing yields an empty list, never a 400.
 */
search?: string;
/**
 * Narrows to one status. There is no way to ask for two.
 */
status?: IdentityUserStatus;
/**
 * Narrows to users holding this role. There is no way to ask for two.
 */
role?: IdentityUserRole;
/**
 * 1-based page number. A page past the last one answers an empty data array, never a 404.
 * @minimum 1
 */
page?: number;
/**
 * Page size.
 * @minimum 1
 * @maximum 100
 */
limit?: number;
/**
 * Field the result is ordered by.
 */
sort_by?: ListIdentityUsersSortBy;
sort_order?: ListIdentityUsersSortOrder;
};

export type ListIdentityUsersSortBy = typeof ListIdentityUsersSortBy[keyof typeof ListIdentityUsersSortBy];


export const ListIdentityUsersSortBy = {
  name: 'name',
  email: 'email',
  created_at: 'created_at',
} as const;

export type ListIdentityUsersSortOrder = typeof ListIdentityUsersSortOrder[keyof typeof ListIdentityUsersSortOrder];


export const ListIdentityUsersSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ListRoleOverviewParams = {
/**
 * 1-based page number. A page past the last one answers an empty data array, never a 404.
 * @minimum 1
 */
page?: number;
/**
 * Page size. The role model is small enough that the default window is the whole of it.
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const login = (
    loginRequest: LoginRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<AuthTokens>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      options);
    }




export const getLoginQueryKey = (loginRequest?: LoginRequest,) => {
    return [
    'POST', `/auth/login`, loginRequest
    ] as const;
    }


export const getLoginQueryOptions = <TData = Awaited<ReturnType<typeof login>>, TError = ProblemResponse>(loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginQueryKey(loginRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof login>>> = ({ signal }) => login(loginRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginQueryResult = NonNullable<Awaited<ReturnType<typeof login>>>
export type LoginQueryError = ProblemResponse


export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof login>>,
          TError,
          Awaited<ReturnType<typeof login>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof login>>,
          TError,
          Awaited<ReturnType<typeof login>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginQueryOptions(loginRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const refreshSession = (
    refreshRequest: RefreshRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<AuthTokens>(
      {url: `/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshRequest, signal
    },
      options);
    }




export const getRefreshSessionQueryKey = (refreshRequest?: RefreshRequest,) => {
    return [
    'POST', `/auth/refresh`, refreshRequest
    ] as const;
    }


export const getRefreshSessionQueryOptions = <TData = Awaited<ReturnType<typeof refreshSession>>, TError = ProblemResponse>(refreshRequest: RefreshRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshSession>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRefreshSessionQueryKey(refreshRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof refreshSession>>> = ({ signal }) => refreshSession(refreshRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof refreshSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RefreshSessionQueryResult = NonNullable<Awaited<ReturnType<typeof refreshSession>>>
export type RefreshSessionQueryError = ProblemResponse


export function useRefreshSession<TData = Awaited<ReturnType<typeof refreshSession>>, TError = ProblemResponse>(
 refreshRequest: RefreshRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof refreshSession>>,
          TError,
          Awaited<ReturnType<typeof refreshSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRefreshSession<TData = Awaited<ReturnType<typeof refreshSession>>, TError = ProblemResponse>(
 refreshRequest: RefreshRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof refreshSession>>,
          TError,
          Awaited<ReturnType<typeof refreshSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRefreshSession<TData = Awaited<ReturnType<typeof refreshSession>>, TError = ProblemResponse>(
 refreshRequest: RefreshRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshSession>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRefreshSession<TData = Awaited<ReturnType<typeof refreshSession>>, TError = ProblemResponse>(
 refreshRequest: RefreshRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshSession>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRefreshSessionQueryOptions(refreshRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCurrentUser = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<SessionUser>(
      {url: `/auth/me`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentUserMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError,void, TContext> => {

const mutationKey = ['getCurrentUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCurrentUser>>, void> = () => {


          return  getCurrentUser(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>

    export type GetCurrentUserMutationError = ProblemResponse

    export const useGetCurrentUser = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCurrentUser>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetCurrentUserMutationOptions(options), queryClient);
    }

export const listUsers = (
    params?: ListUsersParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<UserPage>(
      {url: `/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListUsersMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listUsers>>, TError,{params?: ListUsersParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof listUsers>>, TError,{params?: ListUsersParams}, TContext> => {

const mutationKey = ['listUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listUsers>>, {params?: ListUsersParams}> = (props) => {
          const {params} = props ?? {};

          return  listUsers(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListUsersMutationResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>

    export type ListUsersMutationError = ProblemResponse

    export const useListUsers = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listUsers>>, TError,{params?: ListUsersParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listUsers>>,
        TError,
        {params?: ListUsersParams},
        TContext
      > => {
      return useMutation(getListUsersMutationOptions(options), queryClient);
    }

/**
 * The identifier filter matches a device by its IMEI or its serial — one param for both, since exactly one of the two is present on a record. It is deliberately unvalidated: a value matching nothing yields an empty list, never a 400. Identifier values are sensitive: access logging for this route must not capture query strings.
 * @summary List the tenant's devices (minimal view, identifier filter)
 */
export const listDevices = (
    params?: ListDevicesParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceList>(
      {url: `/v1/devices`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListDevicesMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listDevices>>, TError,{params?: ListDevicesParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof listDevices>>, TError,{params?: ListDevicesParams}, TContext> => {

const mutationKey = ['listDevices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listDevices>>, {params?: ListDevicesParams}> = (props) => {
          const {params} = props ?? {};

          return  listDevices(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListDevicesMutationResult = NonNullable<Awaited<ReturnType<typeof listDevices>>>

    export type ListDevicesMutationError = ProblemResponse

    /**
 * @summary List the tenant's devices (minimal view, identifier filter)
 */
export const useListDevices = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listDevices>>, TError,{params?: ListDevicesParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listDevices>>,
        TError,
        {params?: ListDevicesParams},
        TContext
      > => {
      return useMutation(getListDevicesMutationOptions(options), queryClient);
    }

/**
 * PC-REG-01. The imei pattern is the syntactic half of the check and is answered 400 on violation; the Luhn check digit is semantic, enforced in the service, and answered 422 with violation code imei_luhn_failed. A device already registered for this tenant answers 409. The IMEI value is sensitive: it must not appear in access logs, spans, metrics or error bodies.
 * @summary Register a device by IMEI
 */
export const registerDevice = (
    registerDeviceRequest: RegisterDeviceRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceRecord>(
      {url: `/v1/devices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerDeviceRequest, signal
    },
      options);
    }




export const getRegisterDeviceQueryKey = (registerDeviceRequest?: RegisterDeviceRequest,) => {
    return [
    'POST', `/v1/devices`, registerDeviceRequest
    ] as const;
    }


export const getRegisterDeviceQueryOptions = <TData = Awaited<ReturnType<typeof registerDevice>>, TError = ProblemResponse>(registerDeviceRequest: RegisterDeviceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegisterDeviceQueryKey(registerDeviceRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof registerDevice>>> = ({ signal }) => registerDevice(registerDeviceRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegisterDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof registerDevice>>>
export type RegisterDeviceQueryError = ProblemResponse


export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ProblemResponse>(
 registerDeviceRequest: RegisterDeviceRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerDevice>>,
          TError,
          Awaited<ReturnType<typeof registerDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ProblemResponse>(
 registerDeviceRequest: RegisterDeviceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerDevice>>,
          TError,
          Awaited<ReturnType<typeof registerDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ProblemResponse>(
 registerDeviceRequest: RegisterDeviceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Register a device by IMEI
 */

export function useRegisterDevice<TData = Awaited<ReturnType<typeof registerDevice>>, TError = ProblemResponse>(
 registerDeviceRequest: RegisterDeviceRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegisterDeviceQueryOptions(registerDeviceRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * The detail view of a device: the list record's fields plus the connectivity, build and firmware facts the on-device agent reports. Every field beyond the four the list surface guarantees may be absent or null on a device that has not reported yet — a device is registered before it ever checks in, so a fresh record carries little more than its identifier. Answers 404 for an id this tenant does not own, never another tenant's device. Identifier values are sensitive: access logging for this route must not capture the path.
 * @summary Read one device, with everything the agent last reported about it
 */
export const getDevice = (
    deviceId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<DeviceDetailRecord>(
      {url: `/v1/devices/${deviceId}`, method: 'GET', signal
    },
      options);
    }




export const getGetDeviceMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDevice>>, TError,{deviceId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getDevice>>, TError,{deviceId: string}, TContext> => {

const mutationKey = ['getDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDevice>>, {deviceId: string}> = (props) => {
          const {deviceId} = props ?? {};

          return  getDevice(deviceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof getDevice>>>

    export type GetDeviceMutationError = ProblemResponse

    /**
 * @summary Read one device, with everything the agent last reported about it
 */
export const useGetDevice = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDevice>>, TError,{deviceId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDevice>>,
        TError,
        {deviceId: string},
        TContext
      > => {
      return useMutation(getGetDeviceMutationOptions(options), queryClient);
    }

/**
 * PROVISIONAL — hand-added to the committed spec so the portal can generate a client; not published by the backend as of 2026-09-14 and not walked against a live tenant. Issues a LOCK command and answers with the command row it created. Acceptance is not enforcement: the device's `state` does not move until the device acknowledges, and the caller renders the returned `last_command` as pending, never as a lock that landed. A device with a LOCK already in flight is expected to answer 409 rather than queue a second command. Takes no request body: the lock mode is the platform's to choose and comes back on the command row as `last_command.lock_mode`.
 * @summary Issue a lock command to a device
 */
export const lockDevice = (
    deviceId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<LockDeviceResponse>(
      {url: `/v1/devices/${deviceId}/lock`, method: 'POST', signal
    },
      options);
    }




export const getLockDeviceQueryKey = (deviceId: string,) => {
    return [
    'POST', `/v1/devices/${deviceId}/lock`
    ] as const;
    }


export const getLockDeviceQueryOptions = <TData = Awaited<ReturnType<typeof lockDevice>>, TError = ProblemResponse>(deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lockDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLockDeviceQueryKey(deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lockDevice>>> = ({ signal }) => lockDevice(deviceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: deviceId !== null && deviceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lockDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LockDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof lockDevice>>>
export type LockDeviceQueryError = ProblemResponse


export function useLockDevice<TData = Awaited<ReturnType<typeof lockDevice>>, TError = ProblemResponse>(
 deviceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lockDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lockDevice>>,
          TError,
          Awaited<ReturnType<typeof lockDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLockDevice<TData = Awaited<ReturnType<typeof lockDevice>>, TError = ProblemResponse>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lockDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lockDevice>>,
          TError,
          Awaited<ReturnType<typeof lockDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLockDevice<TData = Awaited<ReturnType<typeof lockDevice>>, TError = ProblemResponse>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lockDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Issue a lock command to a device
 */

export function useLockDevice<TData = Awaited<ReturnType<typeof lockDevice>>, TError = ProblemResponse>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lockDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLockDeviceQueryOptions(deviceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PROVISIONAL — hand-added to the committed spec so the portal can generate a client; not published by the backend as of 2026-09-14 and not walked against a live tenant. Issues an UNLOCK command and answers with the command row it created. Acceptance is not enforcement: the device's `state` does not move until the device acknowledges, and the caller renders the returned `last_command` as pending, never as an unlock that landed. A device with a command already in flight is expected to answer 409 rather than queue a second one. Takes no request body: an unlock has no mode, and `last_command.lock_mode` is null on the row it returns.
 * @summary Issue an unlock command to a device
 */
export const unlockDevice = (
    deviceId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<UnlockDeviceResponse>(
      {url: `/v1/devices/${deviceId}/unlock`, method: 'POST', signal
    },
      options);
    }




export const getUnlockDeviceQueryKey = (deviceId: string,) => {
    return [
    'POST', `/v1/devices/${deviceId}/unlock`
    ] as const;
    }


export const getUnlockDeviceQueryOptions = <TData = Awaited<ReturnType<typeof unlockDevice>>, TError = ProblemResponse>(deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unlockDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnlockDeviceQueryKey(deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof unlockDevice>>> = ({ signal }) => unlockDevice(deviceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: deviceId !== null && deviceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unlockDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UnlockDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof unlockDevice>>>
export type UnlockDeviceQueryError = ProblemResponse


export function useUnlockDevice<TData = Awaited<ReturnType<typeof unlockDevice>>, TError = ProblemResponse>(
 deviceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof unlockDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof unlockDevice>>,
          TError,
          Awaited<ReturnType<typeof unlockDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnlockDevice<TData = Awaited<ReturnType<typeof unlockDevice>>, TError = ProblemResponse>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unlockDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof unlockDevice>>,
          TError,
          Awaited<ReturnType<typeof unlockDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnlockDevice<TData = Awaited<ReturnType<typeof unlockDevice>>, TError = ProblemResponse>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unlockDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Issue an unlock command to a device
 */

export function useUnlockDevice<TData = Awaited<ReturnType<typeof unlockDevice>>, TError = ProblemResponse>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unlockDevice>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUnlockDeviceQueryOptions(deviceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Mirrors the backend contract (cenorion/backend `feat/cen-147`, `create_enrolment`). The device is named by its registered IMEI in the body, never the URL. Only `dfpost` is enabled; the other services answer 422 not-enabled. 409 carries `already-applied` or `invalid-for-state`.
 * @summary Enrol one device into a service
 */
export const createEnrolment = (
    createEnrolmentRequest: CreateEnrolmentRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<EnrolmentRecord>(
      {url: `/v1/enrolments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEnrolmentRequest, signal
    },
      options);
    }




export const getCreateEnrolmentQueryKey = (createEnrolmentRequest?: CreateEnrolmentRequest,) => {
    return [
    'POST', `/v1/enrolments`, createEnrolmentRequest
    ] as const;
    }


export const getCreateEnrolmentQueryOptions = <TData = Awaited<ReturnType<typeof createEnrolment>>, TError = ProblemResponse>(createEnrolmentRequest: CreateEnrolmentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEnrolment>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateEnrolmentQueryKey(createEnrolmentRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createEnrolment>>> = ({ signal }) => createEnrolment(createEnrolmentRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createEnrolment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateEnrolmentQueryResult = NonNullable<Awaited<ReturnType<typeof createEnrolment>>>
export type CreateEnrolmentQueryError = ProblemResponse


export function useCreateEnrolment<TData = Awaited<ReturnType<typeof createEnrolment>>, TError = ProblemResponse>(
 createEnrolmentRequest: CreateEnrolmentRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEnrolment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createEnrolment>>,
          TError,
          Awaited<ReturnType<typeof createEnrolment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateEnrolment<TData = Awaited<ReturnType<typeof createEnrolment>>, TError = ProblemResponse>(
 createEnrolmentRequest: CreateEnrolmentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEnrolment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createEnrolment>>,
          TError,
          Awaited<ReturnType<typeof createEnrolment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateEnrolment<TData = Awaited<ReturnType<typeof createEnrolment>>, TError = ProblemResponse>(
 createEnrolmentRequest: CreateEnrolmentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEnrolment>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Enrol one device into a service
 */

export function useCreateEnrolment<TData = Awaited<ReturnType<typeof createEnrolment>>, TError = ProblemResponse>(
 createEnrolmentRequest: CreateEnrolmentRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createEnrolment>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateEnrolmentQueryOptions(createEnrolmentRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * CEN-1256's contract, hand-added on 2026-09-15 so the portal could generate a client: no part of it has been published by the backend or called against a live tenant, so treat every line here as a design decision awaiting confirmation. The portal reads it as a server-narrowed, server-paged list: the Users and roles page sends whichever of `search`, `role` and `status` are in force along with `page` and `limit`, so a tenant larger than one page is searched whole rather than within the window that happened to arrive first. It also asks once with `limit=1` and no filters, reading only `pagination.total`, for the tenant-wide count the Users tab badge names.
 * @summary List the tenant's users
 */
export const listIdentityUsers = (
    params?: ListIdentityUsersParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUserList>(
      {url: `/v1/identity/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListIdentityUsersMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listIdentityUsers>>, TError,{params?: ListIdentityUsersParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof listIdentityUsers>>, TError,{params?: ListIdentityUsersParams}, TContext> => {

const mutationKey = ['listIdentityUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listIdentityUsers>>, {params?: ListIdentityUsersParams}> = (props) => {
          const {params} = props ?? {};

          return  listIdentityUsers(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListIdentityUsersMutationResult = NonNullable<Awaited<ReturnType<typeof listIdentityUsers>>>

    export type ListIdentityUsersMutationError = ProblemResponse

    /**
 * @summary List the tenant's users
 */
export const useListIdentityUsers = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listIdentityUsers>>, TError,{params?: ListIdentityUsersParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listIdentityUsers>>,
        TError,
        {params?: ListIdentityUsersParams},
        TContext
      > => {
      return useMutation(getListIdentityUsersMutationOptions(options), queryClient);
    }

/**
 * Inviting is creating: the account exists with status PENDING the moment this answers, and the platform mails the credentials. It becomes ACTIVE on the user's first password change, which nothing on this surface reports. An email already registered for this tenant answers 409 with code USER_ALREADY_EXISTS; field-level rejections answer 422 with VALIDATION_ERROR. Omitting role is how the caller takes the platform's default — VIEWER — rather than a distinct "no role" state.
 * @summary Invite a user, creating the account
 */
export const inviteUser = (
    inviteUserRequest: InviteUserRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<InviteUserResponse>(
      {url: `/v1/identity/users/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteUserRequest, signal
    },
      options);
    }




export const getInviteUserQueryKey = (inviteUserRequest?: InviteUserRequest,) => {
    return [
    'POST', `/v1/identity/users/invite`, inviteUserRequest
    ] as const;
    }


export const getInviteUserQueryOptions = <TData = Awaited<ReturnType<typeof inviteUser>>, TError = ProblemResponse>(inviteUserRequest: InviteUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInviteUserQueryKey(inviteUserRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inviteUser>>> = ({ signal }) => inviteUser(inviteUserRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inviteUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InviteUserQueryResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
export type InviteUserQueryError = ProblemResponse


export function useInviteUser<TData = Awaited<ReturnType<typeof inviteUser>>, TError = ProblemResponse>(
 inviteUserRequest: InviteUserRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inviteUser>>,
          TError,
          Awaited<ReturnType<typeof inviteUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInviteUser<TData = Awaited<ReturnType<typeof inviteUser>>, TError = ProblemResponse>(
 inviteUserRequest: InviteUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inviteUser>>,
          TError,
          Awaited<ReturnType<typeof inviteUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInviteUser<TData = Awaited<ReturnType<typeof inviteUser>>, TError = ProblemResponse>(
 inviteUserRequest: InviteUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invite a user, creating the account
 */

export function useInviteUser<TData = Awaited<ReturnType<typeof inviteUser>>, TError = ProblemResponse>(
 inviteUserRequest: InviteUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inviteUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInviteUserQueryOptions(inviteUserRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Mirrors the backend identity contract's `get_user` (contracts/rest/openapi/identity.openapi.yaml). The profile behind a row of the Users list, addressed by the pool `sub` — the same value as `id` on the list surface and the session's OIDC subject — and never by email. Any member of the tenant may read it, so the portal reads its own row here to learn the roles it holds. Absent and foreign are indistinguishable: another tenant's id, an id in no pool, and a pool user never invited all answer the same 404. Beside `user`, `permissions` is the union of what the user's roles grant under the tenant's role definitions — the same set the edge authorizer grants them.
 * @summary One user of the caller's tenant
 */
export const getIdentityUser = (
    userId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<GetIdentityUserResponse>(
      {url: `/v1/identity/users/${userId}`, method: 'GET', signal
    },
      options);
    }




export const getGetIdentityUserMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIdentityUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getIdentityUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['getIdentityUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getIdentityUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  getIdentityUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetIdentityUserMutationResult = NonNullable<Awaited<ReturnType<typeof getIdentityUser>>>

    export type GetIdentityUserMutationError = ProblemResponse

    /**
 * @summary One user of the caller's tenant
 */
export const useGetIdentityUser = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIdentityUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getIdentityUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getGetIdentityUserMutationOptions(options), queryClient);
    }

/**
 * PROVISIONAL — hand-added to the committed spec on 2026-09-22 so the portal can generate a client; not published by the backend and not walked against a live tenant, so treat every line here as a design decision awaiting confirmation. Deactivation is a soft delete: the user loses access immediately, the record stays on the roster with status DEACTIVATED and `deactivated_at` set, and the role they held is kept so a later reactivation can give it back. A user who is already DEACTIVATED is expected to answer 409 rather than move the timestamp. Takes no request body — the path names the move, and there is nothing else to say about it.
 * @summary Deactivate a tenant user
 */
export const deactivateUser = (
    userId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUserResponse>(
      {url: `/v1/identity/users/${userId}/deactivate`, method: 'PATCH', signal
    },
      options);
    }




export const getDeactivateUserQueryKey = (userId: string,) => {
    return [
    'PATCH', `/v1/identity/users/${userId}/deactivate`
    ] as const;
    }


export const getDeactivateUserQueryOptions = <TData = Awaited<ReturnType<typeof deactivateUser>>, TError = ProblemResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deactivateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeactivateUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deactivateUser>>> = ({ signal }) => deactivateUser(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deactivateUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeactivateUserQueryResult = NonNullable<Awaited<ReturnType<typeof deactivateUser>>>
export type DeactivateUserQueryError = ProblemResponse


export function useDeactivateUser<TData = Awaited<ReturnType<typeof deactivateUser>>, TError = ProblemResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deactivateUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deactivateUser>>,
          TError,
          Awaited<ReturnType<typeof deactivateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeactivateUser<TData = Awaited<ReturnType<typeof deactivateUser>>, TError = ProblemResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deactivateUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deactivateUser>>,
          TError,
          Awaited<ReturnType<typeof deactivateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeactivateUser<TData = Awaited<ReturnType<typeof deactivateUser>>, TError = ProblemResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deactivateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Deactivate a tenant user
 */

export function useDeactivateUser<TData = Awaited<ReturnType<typeof deactivateUser>>, TError = ProblemResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deactivateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeactivateUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PROVISIONAL — hand-added to the committed spec on 2026-09-22 so the portal can generate a client; not published by the backend and not walked against a live tenant, so treat every line here as a design decision awaiting confirmation. Gives a deactivated account its access back with the role it was switched off with: status returns to ACTIVE and `deactivated_at` is cleared. A user who is not DEACTIVATED is expected to answer 409 rather than be re-activated; a PENDING invite is not reactivatable, because it was never active. Takes no request body — the path names the move, and there is nothing else to say about it.
 * @summary Reactivate a tenant user
 */
export const reactivateUser = (
    userId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<IdentityUserResponse>(
      {url: `/v1/identity/users/${userId}/reactivate`, method: 'PATCH', signal
    },
      options);
    }




export const getReactivateUserQueryKey = (userId: string,) => {
    return [
    'PATCH', `/v1/identity/users/${userId}/reactivate`
    ] as const;
    }


export const getReactivateUserQueryOptions = <TData = Awaited<ReturnType<typeof reactivateUser>>, TError = ProblemResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reactivateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReactivateUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reactivateUser>>> = ({ signal }) => reactivateUser(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reactivateUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReactivateUserQueryResult = NonNullable<Awaited<ReturnType<typeof reactivateUser>>>
export type ReactivateUserQueryError = ProblemResponse


export function useReactivateUser<TData = Awaited<ReturnType<typeof reactivateUser>>, TError = ProblemResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reactivateUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reactivateUser>>,
          TError,
          Awaited<ReturnType<typeof reactivateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReactivateUser<TData = Awaited<ReturnType<typeof reactivateUser>>, TError = ProblemResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reactivateUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reactivateUser>>,
          TError,
          Awaited<ReturnType<typeof reactivateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReactivateUser<TData = Awaited<ReturnType<typeof reactivateUser>>, TError = ProblemResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reactivateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reactivate a tenant user
 */

export function useReactivateUser<TData = Awaited<ReturnType<typeof reactivateUser>>, TError = ProblemResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reactivateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReactivateUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * One row per role rather than per user — this is what the Roles and permissions tab lists, and it replaces the copy table the portal shipped that surface with. The portal reads it as a plain paged list: it sends `limit` at this contract's maximum and no `page`, because the platform's role set is fixed and small enough to arrive in one window. It renders every role returned, internal-domain ones included, because the list is documentation of the platform's role model rather than a menu of what the caller may grant.
 * @summary List the roles the platform defines, each with the users holding it
 */
export const listRoleOverview = (
    params?: ListRoleOverviewParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<RoleList>(
      {url: `/v1/identity/roles/overview`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListRoleOverviewMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listRoleOverview>>, TError,{params?: ListRoleOverviewParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof listRoleOverview>>, TError,{params?: ListRoleOverviewParams}, TContext> => {

const mutationKey = ['listRoleOverview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listRoleOverview>>, {params?: ListRoleOverviewParams}> = (props) => {
          const {params} = props ?? {};

          return  listRoleOverview(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListRoleOverviewMutationResult = NonNullable<Awaited<ReturnType<typeof listRoleOverview>>>

    export type ListRoleOverviewMutationError = ProblemResponse

    /**
 * @summary List the roles the platform defines, each with the users holding it
 */
export const useListRoleOverview = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listRoleOverview>>, TError,{params?: ListRoleOverviewParams}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listRoleOverview>>,
        TError,
        {params?: ListRoleOverviewParams},
        TContext
      > => {
      return useMutation(getListRoleOverviewMutationOptions(options), queryClient);
    }

export const updateUser = (
    id: string,
    updateUserRequest: UpdateUserRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<User>(
      {url: `/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest, signal
    },
      options);
    }




export const getUpdateUserQueryKey = (id: string,
    updateUserRequest?: UpdateUserRequest,) => {
    return [
    'PATCH', `/users/${id}`, updateUserRequest
    ] as const;
    }


export const getUpdateUserQueryOptions = <TData = Awaited<ReturnType<typeof updateUser>>, TError = ProblemResponse>(id: string,
    updateUserRequest: UpdateUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUpdateUserQueryKey(id,updateUserRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof updateUser>>> = ({ signal }) => updateUser(id,updateUserRequest, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UpdateUserQueryResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
export type UpdateUserQueryError = ProblemResponse


export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ProblemResponse>(
 id: string,
    updateUserRequest: UpdateUserRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateUser>>,
          TError,
          Awaited<ReturnType<typeof updateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ProblemResponse>(
 id: string,
    updateUserRequest: UpdateUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateUser>>,
          TError,
          Awaited<ReturnType<typeof updateUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ProblemResponse>(
 id: string,
    updateUserRequest: UpdateUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUpdateUser<TData = Awaited<ReturnType<typeof updateUser>>, TError = ProblemResponse>(
 id: string,
    updateUserRequest: UpdateUserRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof updateUser>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUpdateUserQueryOptions(id,updateUserRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PC-REG-02. PROPOSED — re-verify against the live API before integration (CEN-1299). Opens an async bulk-registration job for a CSV of devices and returns a presigned upload ticket. The client PUTs the raw file to `upload.url` directly (not through the API client): a near-ceiling file (1M rows, ~40-60 MB) would breach the client's 30s timeout and JSON content-type, and the storage PUT must not carry the bearer token or trigger 401 refresh-and-replay. The job starts in `awaiting_upload`; call POST .../start once the PUT completes. CSV values are never echoed in any response body — identifiers are sensitive (Obs §2.1). Answers 413 file_too_large (see `code`), 415 for a non-CSV content_type, and 422 csv_header_invalid (with the offending columns in `errors.header`) or csv_empty when the header can be pre-checked at open time.
 * @summary Open a bulk registration job and get an upload ticket
 */
export const createBulkRegistration = (
    createBulkRegistrationRequest: CreateBulkRegistrationRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistration>(
      {url: `/v1/devices/bulk-registrations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkRegistrationRequest, signal
    },
      options);
    }




export const getCreateBulkRegistrationQueryKey = (createBulkRegistrationRequest?: CreateBulkRegistrationRequest,) => {
    return [
    'POST', `/v1/devices/bulk-registrations`, createBulkRegistrationRequest
    ] as const;
    }


export const getCreateBulkRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof createBulkRegistration>>, TError = ProblemResponse>(createBulkRegistrationRequest: CreateBulkRegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateBulkRegistrationQueryKey(createBulkRegistrationRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createBulkRegistration>>> = ({ signal }) => createBulkRegistration(createBulkRegistrationRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateBulkRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof createBulkRegistration>>>
export type CreateBulkRegistrationQueryError = ProblemResponse


export function useCreateBulkRegistration<TData = Awaited<ReturnType<typeof createBulkRegistration>>, TError = ProblemResponse>(
 createBulkRegistrationRequest: CreateBulkRegistrationRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createBulkRegistration>>,
          TError,
          Awaited<ReturnType<typeof createBulkRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateBulkRegistration<TData = Awaited<ReturnType<typeof createBulkRegistration>>, TError = ProblemResponse>(
 createBulkRegistrationRequest: CreateBulkRegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createBulkRegistration>>,
          TError,
          Awaited<ReturnType<typeof createBulkRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateBulkRegistration<TData = Awaited<ReturnType<typeof createBulkRegistration>>, TError = ProblemResponse>(
 createBulkRegistrationRequest: CreateBulkRegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Open a bulk registration job and get an upload ticket
 */

export function useCreateBulkRegistration<TData = Awaited<ReturnType<typeof createBulkRegistration>>, TError = ProblemResponse>(
 createBulkRegistrationRequest: CreateBulkRegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateBulkRegistrationQueryOptions(createBulkRegistrationRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PC-REG-02. PROPOSED — re-verify against the live API (CEN-1299). Returns the CSV template whose columns are the published schema the upload validates against, so the template can never drift from what validation expects. UTF-8 (BOM tolerated), comma-delimited, header row required, CRLF tolerated. Assumed columns: `imei, imei2, serial` (identifier-only — see the identifier-contract gap in CEN-1299). Served as an authenticated download; the client fetches it as a blob rather than via a public link.
 * @summary Download the published CSV column template
 */
export const getBulkRegistrationTemplate = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<Blob>(
      {url: `/v1/devices/bulk-registrations/template`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetBulkRegistrationTemplateMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError,void, TContext> => {

const mutationKey = ['getBulkRegistrationTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, void> = () => {


          return  getBulkRegistrationTemplate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetBulkRegistrationTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>>

    export type GetBulkRegistrationTemplateMutationError = ProblemResponse

    /**
 * @summary Download the published CSV column template
 */
export const useGetBulkRegistrationTemplate = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistrationTemplate>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getBulkRegistrationTemplate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetBulkRegistrationTemplateMutationOptions(options), queryClient);
    }

/**
 * PC-REG-02. PROPOSED — re-verify against the live API (CEN-1299). Returns the job with overall and per-batch progress, the three-way outcome totals (registered / rejected / unprocessed), and a counts-only rejection breakdown. Polled by the client until `status` is terminal; no row-level values ever appear here — the rejected rows live only in the results CSV. Answers 404 for an id this tenant does not own.
 * @summary Read a bulk registration job's status and progress
 */
export const getBulkRegistration = (
    bulkRegistrationId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistration>(
      {url: `/v1/devices/bulk-registrations/${bulkRegistrationId}`, method: 'GET', signal
    },
      options);
    }




export const getGetBulkRegistrationMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError,{bulkRegistrationId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError,{bulkRegistrationId: string}, TContext> => {

const mutationKey = ['getBulkRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getBulkRegistration>>, {bulkRegistrationId: string}> = (props) => {
          const {bulkRegistrationId} = props ?? {};

          return  getBulkRegistration(bulkRegistrationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetBulkRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistration>>>

    export type GetBulkRegistrationMutationError = ProblemResponse

    /**
 * @summary Read a bulk registration job's status and progress
 */
export const useGetBulkRegistration = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistration>>, TError,{bulkRegistrationId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getBulkRegistration>>,
        TError,
        {bulkRegistrationId: string},
        TContext
      > => {
      return useMutation(getGetBulkRegistrationMutationOptions(options), queryClient);
    }

/**
 * PC-REG-02. PROPOSED — re-verify against the live API (CEN-1299). Moves a job from `awaiting_upload` to `queued` once its file has been uploaded, and the backend then partitions the file into 10,000-row batches processed asynchronously. Idempotent: a repeat call returns the same job (200) rather than starting it twice. Explicit start (rather than reacting to a storage event) means the client knows the upload landed and the job can never silently hang in `awaiting_upload`. Answers 409 upload_incomplete when no uploaded file is present.
 * @summary Begin processing an uploaded bulk registration job
 */
export const startBulkRegistration = (
    bulkRegistrationId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistration>(
      {url: `/v1/devices/bulk-registrations/${bulkRegistrationId}/start`, method: 'POST', signal
    },
      options);
    }




export const getStartBulkRegistrationQueryKey = (bulkRegistrationId: string,) => {
    return [
    'POST', `/v1/devices/bulk-registrations/${bulkRegistrationId}/start`
    ] as const;
    }


export const getStartBulkRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof startBulkRegistration>>, TError = ProblemResponse>(bulkRegistrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStartBulkRegistrationQueryKey(bulkRegistrationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof startBulkRegistration>>> = ({ signal }) => startBulkRegistration(bulkRegistrationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: bulkRegistrationId !== null && bulkRegistrationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StartBulkRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof startBulkRegistration>>>
export type StartBulkRegistrationQueryError = ProblemResponse


export function useStartBulkRegistration<TData = Awaited<ReturnType<typeof startBulkRegistration>>, TError = ProblemResponse>(
 bulkRegistrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof startBulkRegistration>>,
          TError,
          Awaited<ReturnType<typeof startBulkRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStartBulkRegistration<TData = Awaited<ReturnType<typeof startBulkRegistration>>, TError = ProblemResponse>(
 bulkRegistrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof startBulkRegistration>>,
          TError,
          Awaited<ReturnType<typeof startBulkRegistration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStartBulkRegistration<TData = Awaited<ReturnType<typeof startBulkRegistration>>, TError = ProblemResponse>(
 bulkRegistrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Begin processing an uploaded bulk registration job
 */

export function useStartBulkRegistration<TData = Awaited<ReturnType<typeof startBulkRegistration>>, TError = ProblemResponse>(
 bulkRegistrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStartBulkRegistrationQueryOptions(bulkRegistrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PC-REG-02/AC3. PROPOSED — re-verify against the live API (CEN-1299). Re-runs a single batch that ended in `failed` (an infrastructure fault, not row rejections). Idempotent per row: only rows without a terminal outcome are reprocessed, and rows this same job already registered are never re-counted as `duplicate_existing` — without that guarantee a batch that died mid-way would re-register its earlier rows as duplicates on retry. Moves the job back to `processing`; the results file regenerates on completion. Answers 409 when the batch is not in `failed`.
 * @summary Re-run a failed batch of a bulk registration job
 */
export const retryBulkRegistrationBatch = (
    bulkRegistrationId: string,
    batchIndex: number,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistration>(
      {url: `/v1/devices/bulk-registrations/${bulkRegistrationId}/batches/${batchIndex}/retry`, method: 'POST', signal
    },
      options);
    }




export const getRetryBulkRegistrationBatchQueryKey = (bulkRegistrationId: string,
    batchIndex: number,) => {
    return [
    'POST', `/v1/devices/bulk-registrations/${bulkRegistrationId}/batches/${batchIndex}/retry`
    ] as const;
    }


export const getRetryBulkRegistrationBatchQueryOptions = <TData = Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError = ProblemResponse>(bulkRegistrationId: string,
    batchIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetryBulkRegistrationBatchQueryKey(bulkRegistrationId,batchIndex);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>> = ({ signal }) => retryBulkRegistrationBatch(bulkRegistrationId,batchIndex, requestOptions, signal);





   return  { queryKey, queryFn, enabled: bulkRegistrationId !== null && bulkRegistrationId !== undefined && batchIndex !== null && batchIndex !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetryBulkRegistrationBatchQueryResult = NonNullable<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>>
export type RetryBulkRegistrationBatchQueryError = ProblemResponse


export function useRetryBulkRegistrationBatch<TData = Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError = ProblemResponse>(
 bulkRegistrationId: string,
    batchIndex: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retryBulkRegistrationBatch>>,
          TError,
          Awaited<ReturnType<typeof retryBulkRegistrationBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetryBulkRegistrationBatch<TData = Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError = ProblemResponse>(
 bulkRegistrationId: string,
    batchIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retryBulkRegistrationBatch>>,
          TError,
          Awaited<ReturnType<typeof retryBulkRegistrationBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetryBulkRegistrationBatch<TData = Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError = ProblemResponse>(
 bulkRegistrationId: string,
    batchIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Re-run a failed batch of a bulk registration job
 */

export function useRetryBulkRegistrationBatch<TData = Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError = ProblemResponse>(
 bulkRegistrationId: string,
    batchIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retryBulkRegistrationBatch>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetryBulkRegistrationBatchQueryOptions(bulkRegistrationId,batchIndex,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PC-REG-02/AC2. PROPOSED — re-verify against the live API (CEN-1299). Returns one consolidated CSV covering every batch, listing each rejected row with its typed reason: columns `row_number, reason_code, reason_detail` followed by the original row's columns echoed back. This is the only surface that carries row values — it is an authenticated download the client fetches as a blob, never a public/presigned link, because the file contains IMEIs and a signed URL would land in browser history, devtools and network logs. Answers 409/404 while the file is not yet available.
 * @summary Download the consolidated rejected-rows results file
 */
export const getBulkRegistrationResults = (
    bulkRegistrationId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<Blob>(
      {url: `/v1/devices/bulk-registrations/${bulkRegistrationId}/results`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetBulkRegistrationResultsMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError,{bulkRegistrationId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError,{bulkRegistrationId: string}, TContext> => {

const mutationKey = ['getBulkRegistrationResults'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getBulkRegistrationResults>>, {bulkRegistrationId: string}> = (props) => {
          const {bulkRegistrationId} = props ?? {};

          return  getBulkRegistrationResults(bulkRegistrationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetBulkRegistrationResultsMutationResult = NonNullable<Awaited<ReturnType<typeof getBulkRegistrationResults>>>

    export type GetBulkRegistrationResultsMutationError = ProblemResponse

    /**
 * @summary Download the consolidated rejected-rows results file
 */
export const useGetBulkRegistrationResults = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBulkRegistrationResults>>, TError,{bulkRegistrationId: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getBulkRegistrationResults>>,
        TError,
        {bulkRegistrationId: string},
        TContext
      > => {
      return useMutation(getGetBulkRegistrationResultsMutationOptions(options), queryClient);
    }

/**
 * PROVISIONAL — hand-added to the committed spec on 2026-10-01 from the backend's TenantBrandingResponse JSON schema so the portal can generate a client. The tenant comes from the verified token; no path or query names it. A tenant whose branding was never set up is answered 404, not an empty set.
 * @summary Read the tenant's branding set in force
 */
export const getTenantBranding = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantBrandingResponse>(
      {url: `/v1/tenants/me/branding`, method: 'GET', signal
    },
      options);
    }




export const getGetTenantBrandingMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError,void, TContext> => {

const mutationKey = ['getTenantBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTenantBranding>>, void> = () => {


          return  getTenantBranding(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTenantBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof getTenantBranding>>>

    export type GetTenantBrandingMutationError = ProblemResponse

    /**
 * @summary Read the tenant's branding set in force
 */
export const useGetTenantBranding = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTenantBranding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTenantBrandingMutationOptions(options), queryClient);
    }

/**
 * PROVISIONAL — hand-added to the committed spec on 2026-10-01 from the backend's TenantBrandingRequest JSON schema. Full replace: a field left out is not 'keep the previous value', and a request without `logo_full` removes the tenant's full logo (devices then show `logo_icon`). The schema checks shape and coarse length only; the file rules (valid base64, content matching media_type, at most 1 MB decoded, square, PNG 256 to 2048 px and not animated, the SVG allowlist) are checked by the service and answered 422.
 * @summary Publish the tenant's whole branding set
 */
export const replaceTenantBranding = (
    tenantBrandingRequest: TenantBrandingRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantBrandingResponse>(
      {url: `/v1/tenants/me/branding`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tenantBrandingRequest, signal
    },
      options);
    }




export const getReplaceTenantBrandingQueryKey = (tenantBrandingRequest?: TenantBrandingRequest,) => {
    return [
    'PUT', `/v1/tenants/me/branding`, tenantBrandingRequest
    ] as const;
    }


export const getReplaceTenantBrandingQueryOptions = <TData = Awaited<ReturnType<typeof replaceTenantBranding>>, TError = ProblemResponse>(tenantBrandingRequest: TenantBrandingRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof replaceTenantBranding>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReplaceTenantBrandingQueryKey(tenantBrandingRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof replaceTenantBranding>>> = ({ signal }) => replaceTenantBranding(tenantBrandingRequest, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof replaceTenantBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReplaceTenantBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof replaceTenantBranding>>>
export type ReplaceTenantBrandingQueryError = ProblemResponse


export function useReplaceTenantBranding<TData = Awaited<ReturnType<typeof replaceTenantBranding>>, TError = ProblemResponse>(
 tenantBrandingRequest: TenantBrandingRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof replaceTenantBranding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof replaceTenantBranding>>,
          TError,
          Awaited<ReturnType<typeof replaceTenantBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReplaceTenantBranding<TData = Awaited<ReturnType<typeof replaceTenantBranding>>, TError = ProblemResponse>(
 tenantBrandingRequest: TenantBrandingRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof replaceTenantBranding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof replaceTenantBranding>>,
          TError,
          Awaited<ReturnType<typeof replaceTenantBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReplaceTenantBranding<TData = Awaited<ReturnType<typeof replaceTenantBranding>>, TError = ProblemResponse>(
 tenantBrandingRequest: TenantBrandingRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof replaceTenantBranding>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Publish the tenant's whole branding set
 */

export function useReplaceTenantBranding<TData = Awaited<ReturnType<typeof replaceTenantBranding>>, TError = ProblemResponse>(
 tenantBrandingRequest: TenantBrandingRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof replaceTenantBranding>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReplaceTenantBrandingQueryOptions(tenantBrandingRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * PROVISIONAL — hand-added to the committed spec on 2026-10-01 from the backend's TenantWhitelistsResponse JSON schema so the portal can generate a client. The tenant comes from the verified token; no path or query names it.
 * @summary List the tenant's whitelists
 */
export const listTenantWhitelists = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantWhitelistsResponse>(
      {url: `/v1/tenants/me/whitelists`, method: 'GET', signal
    },
      options);
    }




export const getListTenantWhitelistsMutationOptions = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError,void, TContext> => {

const mutationKey = ['listTenantWhitelists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listTenantWhitelists>>, void> = () => {


          return  listTenantWhitelists(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListTenantWhitelistsMutationResult = NonNullable<Awaited<ReturnType<typeof listTenantWhitelists>>>

    export type ListTenantWhitelistsMutationError = ProblemResponse

    /**
 * @summary List the tenant's whitelists
 */
export const useListTenantWhitelists = <TError = ProblemResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError,void, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listTenantWhitelists>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getListTenantWhitelistsMutationOptions(options), queryClient);
    }


export const getLoginResponseMock = (overrideResponse: Partial<Extract<AuthTokens, object>> = {}): AuthTokens => ({accessToken: faker.string.alpha({length: {min: 10, max: 20}}), refreshToken: faker.string.alpha({length: {min: 10, max: 20}}), expiresIn: faker.number.int(), ...overrideResponse})

export const getRefreshSessionResponseMock = (overrideResponse: Partial<Extract<AuthTokens, object>> = {}): AuthTokens => ({accessToken: faker.string.alpha({length: {min: 10, max: 20}}), refreshToken: faker.string.alpha({length: {min: 10, max: 20}}), expiresIn: faker.number.int(), ...overrideResponse})

export const getGetCurrentUserResponseMock = (overrideResponse: Partial<Extract<SessionUser, object>> = {}): SessionUser => ({id: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), tenantId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), roles: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), permissions: faker.helpers.arrayElement([Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), undefined]), ...overrideResponse})

export const getListUsersResponseMock = (overrideResponse: Partial<Extract<UserPage, object>> = {}): UserPage => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(UserStatus)), ownerId: faker.string.alpha({length: {min: 10, max: 20}}), tenantId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), createdAt: faker.date.past().toISOString().slice(0, 19) + 'Z'})), page: faker.number.int(), pageSize: faker.number.int(), total: faker.number.int(), ...overrideResponse})

export const getListDevicesResponseMock = (overrideResponse: Partial<Extract<DeviceList, object>> = {}): DeviceList => ({devices: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({device_id: faker.string.uuid(), imei: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[0-9]{15}$"), undefined]), serial: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', state: faker.helpers.arrayElement([faker.helpers.arrayElement(['INVENTORY','ENROLLED','ACTIVE','LOCKED','RELEASED'] as const), undefined]), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), last_command: faker.helpers.arrayElement([{command_id: faker.string.alpha({length: {min: 10, max: 20}}), action: faker.helpers.arrayElement(['LOCK','UNLOCK','RELEASE'] as const), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), status: faker.helpers.arrayElement(['QUEUED','SENT','PENDING_AGENT','ACKED','FAILED','EXPIRED','SUPERSEDED'] as const), issued_at: faker.date.past().toISOString().slice(0, 19) + 'Z', expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), allowed_actions: faker.helpers.arrayElement([faker.helpers.arrayElements(['ENROL','UNENROL','MESSAGE','LOCK','RELEASE','UNLOCK'] as const), undefined]), service: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(EnrolmentService)), undefined])})), pagination: {page: faker.number.int(), limit: faker.number.int(), total: faker.number.int(), total_pages: faker.number.int()}, ...overrideResponse})

export const getRegisterDeviceResponseMock = (overrideResponse: Partial<Extract<DeviceRecord, object>> = {}): DeviceRecord => ({device_id: faker.string.uuid(), imei: faker.helpers.arrayElement([faker.helpers.fromRegExp("^[0-9]{15}$"), undefined]), serial: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', state: faker.helpers.arrayElement([faker.helpers.arrayElement(['INVENTORY','ENROLLED','ACTIVE','LOCKED','RELEASED'] as const), undefined]), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), last_command: faker.helpers.arrayElement([{command_id: faker.string.alpha({length: {min: 10, max: 20}}), action: faker.helpers.arrayElement(['LOCK','UNLOCK','RELEASE'] as const), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), status: faker.helpers.arrayElement(['QUEUED','SENT','PENDING_AGENT','ACKED','FAILED','EXPIRED','SUPERSEDED'] as const), issued_at: faker.date.past().toISOString().slice(0, 19) + 'Z', expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), allowed_actions: faker.helpers.arrayElement([faker.helpers.arrayElements(['ENROL','UNENROL','MESSAGE','LOCK','RELEASE','UNLOCK'] as const), undefined]), service: faker.helpers.arrayElement([faker.helpers.arrayElement(Object.values(EnrolmentService)), undefined]), ...overrideResponse})

export const getGetDeviceResponseMock = (overrideResponse: Partial<Extract<DeviceDetailRecord, object>> = {}): DeviceDetailRecord => ({device_id: faker.string.uuid(), imei: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.helpers.fromRegExp("^[0-9]{15}$"), null]), undefined]), serial: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', state: faker.helpers.arrayElement([faker.helpers.arrayElement(['INVENTORY','ENROLLED','ACTIVE','LOCKED','RELEASED'] as const), undefined]), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), last_command: faker.helpers.arrayElement([{command_id: faker.string.alpha({length: {min: 10, max: 20}}), action: faker.helpers.arrayElement(['LOCK','UNLOCK','RELEASE'] as const), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), status: faker.helpers.arrayElement(['QUEUED','SENT','PENDING_AGENT','ACKED','FAILED','EXPIRED','SUPERSEDED'] as const), issued_at: faker.date.past().toISOString().slice(0, 19) + 'Z', expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), allowed_actions: faker.helpers.arrayElement([faker.helpers.arrayElements(['ENROL','UNENROL','MESSAGE','LOCK','RELEASE','UNLOCK'] as const), undefined]), connectivity_status: faker.helpers.arrayElement(['UNPROVISIONED','ONLINE','OFFLINE'] as const), last_seen_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), android_id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), android_version: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), device_model_name: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), device_model_id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), device_properties: faker.helpers.arrayElement([faker.helpers.arrayElement([{board: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), brand: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), hardware: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), manufacturer: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), ram_mb: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined]), storage_gb: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined])},null,]), undefined]), device_version_properties: faker.helpers.arrayElement([faker.helpers.arrayElement([{sdk_int: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined]), build_id: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), bootloader: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), kernel_version: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), security_patch: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined])},null,]), undefined]), user_serial: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined]), enrolments: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({enrolment_id: faker.string.uuid(), service: faker.helpers.arrayElement(Object.values(EnrolmentService)), state: faker.helpers.arrayElement(Object.values(EnrolmentState)), entered_at: faker.date.past().toISOString().slice(0, 19) + 'Z', closed: faker.datatype.boolean(), plan_id: faker.helpers.arrayElement([faker.string.uuid(), null]), workflow_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null])})), ...overrideResponse})

export const getLockDeviceResponseMock = (overrideResponse: Partial<Extract<LockDeviceResponse, object>> = {}): LockDeviceResponse => ({command_id: faker.string.alpha({length: {min: 10, max: 20}}), last_command: {command_id: faker.string.alpha({length: {min: 10, max: 20}}), action: faker.helpers.arrayElement(['LOCK','UNLOCK','RELEASE'] as const), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), status: faker.helpers.arrayElement(['QUEUED','SENT','PENDING_AGENT','ACKED','FAILED','EXPIRED','SUPERSEDED'] as const), issued_at: faker.date.past().toISOString().slice(0, 19) + 'Z', expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, ...overrideResponse})

export const getUnlockDeviceResponseMock = (overrideResponse: Partial<Extract<UnlockDeviceResponse, object>> = {}): UnlockDeviceResponse => ({command_id: faker.string.alpha({length: {min: 10, max: 20}}), last_command: {command_id: faker.string.alpha({length: {min: 10, max: 20}}), action: faker.helpers.arrayElement(['LOCK','UNLOCK','RELEASE'] as const), lock_mode: faker.helpers.arrayElement([faker.helpers.arrayElement(['FULL','PARTIAL'] as const), undefined]), status: faker.helpers.arrayElement(['QUEUED','SENT','PENDING_AGENT','ACKED','FAILED','EXPIRED','SUPERSEDED'] as const), issued_at: faker.date.past().toISOString().slice(0, 19) + 'Z', expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, ...overrideResponse})

export const getCreateEnrolmentResponseMock = (overrideResponse: Partial<Extract<EnrolmentRecord, object>> = {}): EnrolmentRecord => ({enrolment_id: faker.string.uuid(), device_id: faker.string.uuid(), service: faker.helpers.arrayElement(Object.values(EnrolmentService)), state: faker.helpers.arrayElement(Object.values(EnrolmentState)), entered_at: faker.date.past().toISOString().slice(0, 19) + 'Z', plan_id: faker.helpers.arrayElement([faker.string.uuid(), null]), workflow_version: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), correlation_id: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

export const getListIdentityUsersResponseMock = (overrideResponse: Partial<Extract<IdentityUserList, object>> = {}): IdentityUserList => ({data: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), roles: faker.helpers.arrayElements(Object.values(IdentityUserRole)), status: faker.helpers.arrayElement(Object.values(IdentityUserStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', reactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), deactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), invite_expires_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined])})), pagination: {page: faker.number.int(), limit: faker.number.int(), total: faker.number.int(), total_pages: faker.number.int()}, ...overrideResponse})

export const getInviteUserResponseMock = (overrideResponse: Partial<Extract<InviteUserResponse, object>> = {}): InviteUserResponse => ({user: {id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), roles: faker.helpers.arrayElements(Object.values(IdentityUserRole)), status: faker.helpers.arrayElement(Object.values(IdentityUserStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', reactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), deactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), invite_expires_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined])}, ...overrideResponse})

export const getGetIdentityUserResponseMock = (overrideResponse: Partial<Extract<GetIdentityUserResponse, object>> = {}): GetIdentityUserResponse => ({user: {id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), roles: faker.helpers.arrayElements(Object.values(IdentityUserRole)), status: faker.helpers.arrayElement(Object.values(IdentityUserStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', reactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), deactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), invite_expires_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined])}, permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 1, max: 20}}))), ...overrideResponse})

export const getDeactivateUserResponseMock = (overrideResponse: Partial<Extract<IdentityUserResponse, object>> = {}): IdentityUserResponse => ({user: {id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), roles: faker.helpers.arrayElements(Object.values(IdentityUserRole)), status: faker.helpers.arrayElement(Object.values(IdentityUserStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', reactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), deactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), invite_expires_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined])}, ...overrideResponse})

export const getReactivateUserResponseMock = (overrideResponse: Partial<Extract<IdentityUserResponse, object>> = {}): IdentityUserResponse => ({user: {id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), roles: faker.helpers.arrayElements(Object.values(IdentityUserRole)), status: faker.helpers.arrayElement(Object.values(IdentityUserStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', updated_at: faker.date.past().toISOString().slice(0, 19) + 'Z', reactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), deactivated_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined]), invite_expires_at: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', null]), undefined])}, ...overrideResponse})

export const getListRoleOverviewResponseMock = (overrideResponse: Partial<Extract<RoleList, object>> = {}): RoleList => ({data: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({value: faker.helpers.arrayElement(Object.values(IdentityUserRole)), label: faker.string.alpha({length: {min: 10, max: 20}}), domain: faker.helpers.arrayElement(Object.values(RoleDomain)), scope: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), is_default: faker.datatype.boolean(), assignable: faker.datatype.boolean(), permissions: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}}))), summary: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}),{
        [faker.string.alphanumeric(5)]: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => (faker.string.alpha({length: {min: 10, max: 20}})))
      },]), grantable_by: faker.helpers.arrayElements(Object.values(IdentityUserRole)), users: {total: faker.number.int(), sample: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email()}))}, caveat: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), null]), undefined])})), pagination: {page: faker.number.int(), limit: faker.number.int(), total: faker.number.int(), total_pages: faker.number.int()}, ...overrideResponse})

export const getUpdateUserResponseMock = (overrideResponse: Partial<Extract<User, object>> = {}): User => ({id: faker.string.alpha({length: {min: 10, max: 20}}), email: faker.internet.email(), displayName: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(UserStatus)), ownerId: faker.string.alpha({length: {min: 10, max: 20}}), tenantId: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), createdAt: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

export const getCreateBulkRegistrationResponseMock = (overrideResponse: Partial<Extract<BulkRegistration, object>> = {}): BulkRegistration => ({id: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(BulkRegistrationStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.string.alpha({length: {min: 10, max: 20}}), started_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), file: {name: faker.string.alpha({length: {min: 10, max: 20}}), size_bytes: faker.number.int(), row_count: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined])}, batch_size: faker.number.int(), batches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({index: faker.number.int(), row_from: faker.number.int(), row_to: faker.number.int(), status: faker.helpers.arrayElement(Object.values(BulkRegistrationBatchStatus)), registered: faker.number.int(), rejected: faker.number.int()})), totals: {rows: faker.number.int(), registered: faker.number.int(), rejected: faker.number.int(), unprocessed: faker.number.int()}, rejection_breakdown: {
        [faker.string.alphanumeric(5)]: faker.number.int()
      }, upload: faker.helpers.arrayElement([{url: faker.string.alpha({length: {min: 10, max: 20}}), method: faker.helpers.arrayElement(['PUT'] as const), headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), results: {available: faker.datatype.boolean()}, ...overrideResponse})

export const getGetBulkRegistrationTemplateResponseMock = (): ArrayBuffer => (new ArrayBuffer(faker.number.int({ min: 1, max: 64 })))

export const getGetBulkRegistrationResponseMock = (overrideResponse: Partial<Extract<BulkRegistration, object>> = {}): BulkRegistration => ({id: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(BulkRegistrationStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.string.alpha({length: {min: 10, max: 20}}), started_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), file: {name: faker.string.alpha({length: {min: 10, max: 20}}), size_bytes: faker.number.int(), row_count: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined])}, batch_size: faker.number.int(), batches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({index: faker.number.int(), row_from: faker.number.int(), row_to: faker.number.int(), status: faker.helpers.arrayElement(Object.values(BulkRegistrationBatchStatus)), registered: faker.number.int(), rejected: faker.number.int()})), totals: {rows: faker.number.int(), registered: faker.number.int(), rejected: faker.number.int(), unprocessed: faker.number.int()}, rejection_breakdown: {
        [faker.string.alphanumeric(5)]: faker.number.int()
      }, upload: faker.helpers.arrayElement([{url: faker.string.alpha({length: {min: 10, max: 20}}), method: faker.helpers.arrayElement(['PUT'] as const), headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), results: {available: faker.datatype.boolean()}, ...overrideResponse})

export const getStartBulkRegistrationResponseMock = (overrideResponse: Partial<Extract<BulkRegistration, object>> = {}): BulkRegistration => (faker.helpers.arrayElement([{id: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(BulkRegistrationStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.string.alpha({length: {min: 10, max: 20}}), started_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), file: {name: faker.string.alpha({length: {min: 10, max: 20}}), size_bytes: faker.number.int(), row_count: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined])}, batch_size: faker.number.int(), batches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({index: faker.number.int(), row_from: faker.number.int(), row_to: faker.number.int(), status: faker.helpers.arrayElement(Object.values(BulkRegistrationBatchStatus)), registered: faker.number.int(), rejected: faker.number.int()})), totals: {rows: faker.number.int(), registered: faker.number.int(), rejected: faker.number.int(), unprocessed: faker.number.int()}, rejection_breakdown: {
        [faker.string.alphanumeric(5)]: faker.number.int()
      }, upload: faker.helpers.arrayElement([{url: faker.string.alpha({length: {min: 10, max: 20}}), method: faker.helpers.arrayElement(['PUT'] as const), headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), results: {available: faker.datatype.boolean()}, ...overrideResponse}, {id: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(BulkRegistrationStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.string.alpha({length: {min: 10, max: 20}}), started_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), file: {name: faker.string.alpha({length: {min: 10, max: 20}}), size_bytes: faker.number.int(), row_count: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined])}, batch_size: faker.number.int(), batches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({index: faker.number.int(), row_from: faker.number.int(), row_to: faker.number.int(), status: faker.helpers.arrayElement(Object.values(BulkRegistrationBatchStatus)), registered: faker.number.int(), rejected: faker.number.int()})), totals: {rows: faker.number.int(), registered: faker.number.int(), rejected: faker.number.int(), unprocessed: faker.number.int()}, rejection_breakdown: {
        [faker.string.alphanumeric(5)]: faker.number.int()
      }, upload: faker.helpers.arrayElement([{url: faker.string.alpha({length: {min: 10, max: 20}}), method: faker.helpers.arrayElement(['PUT'] as const), headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), results: {available: faker.datatype.boolean()}, ...overrideResponse}]))

export const getRetryBulkRegistrationBatchResponseMock = (overrideResponse: Partial<Extract<BulkRegistration, object>> = {}): BulkRegistration => ({id: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.helpers.arrayElement(Object.values(BulkRegistrationStatus)), created_at: faker.date.past().toISOString().slice(0, 19) + 'Z', created_by: faker.string.alpha({length: {min: 10, max: 20}}), started_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), completed_at: faker.helpers.arrayElement([faker.date.past().toISOString().slice(0, 19) + 'Z', undefined]), file: {name: faker.string.alpha({length: {min: 10, max: 20}}), size_bytes: faker.number.int(), row_count: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.number.int(), null]), undefined])}, batch_size: faker.number.int(), batches: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({index: faker.number.int(), row_from: faker.number.int(), row_to: faker.number.int(), status: faker.helpers.arrayElement(Object.values(BulkRegistrationBatchStatus)), registered: faker.number.int(), rejected: faker.number.int()})), totals: {rows: faker.number.int(), registered: faker.number.int(), rejected: faker.number.int(), unprocessed: faker.number.int()}, rejection_breakdown: {
        [faker.string.alphanumeric(5)]: faker.number.int()
      }, upload: faker.helpers.arrayElement([{url: faker.string.alpha({length: {min: 10, max: 20}}), method: faker.helpers.arrayElement(['PUT'] as const), headers: faker.helpers.arrayElement([{
        [faker.string.alphanumeric(5)]: faker.string.alpha({length: {min: 10, max: 20}})
      }, undefined]), expires_at: faker.date.past().toISOString().slice(0, 19) + 'Z'}, undefined]), results: {available: faker.datatype.boolean()}, ...overrideResponse})

export const getGetBulkRegistrationResultsResponseMock = (): ArrayBuffer => (new ArrayBuffer(faker.number.int({ min: 1, max: 64 })))

export const getGetTenantBrandingResponseMock = (overrideResponse: Partial<Extract<TenantBrandingResponse, object>> = {}): TenantBrandingResponse => ({display_name: faker.string.alpha({length: {min: 1, max: 32}}), logo_icon: {media_type: faker.helpers.arrayElement(['image/png','image/svg+xml'] as const), data: faker.string.alpha({length: {min: 1, max: 1420000}})}, logo_full: {media_type: faker.helpers.arrayElement(['image/png','image/svg+xml'] as const), data: faker.string.alpha({length: {min: 1, max: 1420000}})}, theme: faker.helpers.arrayElement(Object.values(TenantBrandingTheme)), colors: {primary: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$"), secondary: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$"), accent: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$"), surface: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$")}, currency: {code: faker.helpers.fromRegExp("^[A-Z]{3}$"), symbol: faker.string.alpha({length: {min: 1, max: 5}})}, assets_version: faker.number.int({min: 1}), ...overrideResponse})

export const getReplaceTenantBrandingResponseMock = (overrideResponse: Partial<Extract<TenantBrandingResponse, object>> = {}): TenantBrandingResponse => ({display_name: faker.string.alpha({length: {min: 1, max: 32}}), logo_icon: {media_type: faker.helpers.arrayElement(['image/png','image/svg+xml'] as const), data: faker.string.alpha({length: {min: 1, max: 1420000}})}, logo_full: {media_type: faker.helpers.arrayElement(['image/png','image/svg+xml'] as const), data: faker.string.alpha({length: {min: 1, max: 1420000}})}, theme: faker.helpers.arrayElement(Object.values(TenantBrandingTheme)), colors: {primary: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$"), secondary: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$"), accent: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$"), surface: faker.helpers.fromRegExp("^#[0-9a-fA-F]{6}$")}, currency: {code: faker.helpers.fromRegExp("^[A-Z]{3}$"), symbol: faker.string.alpha({length: {min: 1, max: 5}})}, assets_version: faker.number.int({min: 1}), ...overrideResponse})

export const getListTenantWhitelistsResponseMock = (overrideResponse: Partial<Extract<TenantWhitelistsResponse, object>> = {}): TenantWhitelistsResponse => ({whitelists: Array.from({ length: faker.number.int({min: 1, max: 50}) }, (_, i) => i + 1).map(() => ({id: faker.string.alpha({length: {min: 1, max: 64}}), name: faker.helpers.fromRegExp("^(?=.*\\S)[^\\u0000-\\u001f\\u007f\\u0085\\u2028\\u2029]+$"), is_default: faker.datatype.boolean(), version: faker.number.int({min: 1})})), ...overrideResponse})


export const getLoginMockHandler = (overrideResponse?: AuthTokens | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<AuthTokens> | AuthTokens), options?: RequestHandlerOptions) => {
  return http.post('*/auth/login', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getLoginResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRefreshSessionMockHandler = (overrideResponse?: AuthTokens | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<AuthTokens> | AuthTokens), options?: RequestHandlerOptions) => {
  return http.post('*/auth/refresh', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRefreshSessionResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetCurrentUserMockHandler = (overrideResponse?: SessionUser | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<SessionUser> | SessionUser), options?: RequestHandlerOptions) => {
  return http.get('*/auth/me', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetCurrentUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListUsersMockHandler = (overrideResponse?: UserPage | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<UserPage> | UserPage), options?: RequestHandlerOptions) => {
  return http.get('*/users', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListUsersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListDevicesMockHandler = (overrideResponse?: DeviceList | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<DeviceList> | DeviceList), options?: RequestHandlerOptions) => {
  return http.get('*/v1/devices', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListDevicesResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRegisterDeviceMockHandler = (overrideResponse?: DeviceRecord | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<DeviceRecord> | DeviceRecord), options?: RequestHandlerOptions) => {
  return http.post('*/v1/devices', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRegisterDeviceResponseMock(),
      { status: 201
      })
  }, options)
}

export const getGetDeviceMockHandler = (overrideResponse?: DeviceDetailRecord | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<DeviceDetailRecord> | DeviceDetailRecord), options?: RequestHandlerOptions) => {
  return http.get('*/v1/devices/:deviceId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetDeviceResponseMock(),
      { status: 200
      })
  }, options)
}

export const getLockDeviceMockHandler = (overrideResponse?: LockDeviceResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<LockDeviceResponse> | LockDeviceResponse), options?: RequestHandlerOptions) => {
  return http.post('*/v1/devices/:deviceId/lock', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getLockDeviceResponseMock(),
      { status: 202
      })
  }, options)
}

export const getUnlockDeviceMockHandler = (overrideResponse?: UnlockDeviceResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<UnlockDeviceResponse> | UnlockDeviceResponse), options?: RequestHandlerOptions) => {
  return http.post('*/v1/devices/:deviceId/unlock', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUnlockDeviceResponseMock(),
      { status: 202
      })
  }, options)
}

export const getCreateEnrolmentMockHandler = (overrideResponse?: EnrolmentRecord | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<EnrolmentRecord> | EnrolmentRecord), options?: RequestHandlerOptions) => {
  return http.post('*/v1/enrolments', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateEnrolmentResponseMock(),
      { status: 201
      })
  }, options)
}

export const getListIdentityUsersMockHandler = (overrideResponse?: IdentityUserList | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<IdentityUserList> | IdentityUserList), options?: RequestHandlerOptions) => {
  return http.get('*/v1/identity/users', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListIdentityUsersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getInviteUserMockHandler = (overrideResponse?: InviteUserResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<InviteUserResponse> | InviteUserResponse), options?: RequestHandlerOptions) => {
  return http.post('*/v1/identity/users/invite', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getInviteUserResponseMock(),
      { status: 201
      })
  }, options)
}

export const getGetIdentityUserMockHandler = (overrideResponse?: GetIdentityUserResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<GetIdentityUserResponse> | GetIdentityUserResponse), options?: RequestHandlerOptions) => {
  return http.get('*/v1/identity/users/:userId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetIdentityUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getDeactivateUserMockHandler = (overrideResponse?: IdentityUserResponse | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<IdentityUserResponse> | IdentityUserResponse), options?: RequestHandlerOptions) => {
  return http.patch('*/v1/identity/users/:userId/deactivate', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getDeactivateUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getReactivateUserMockHandler = (overrideResponse?: IdentityUserResponse | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<IdentityUserResponse> | IdentityUserResponse), options?: RequestHandlerOptions) => {
  return http.patch('*/v1/identity/users/:userId/reactivate', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getReactivateUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListRoleOverviewMockHandler = (overrideResponse?: RoleList | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<RoleList> | RoleList), options?: RequestHandlerOptions) => {
  return http.get('*/v1/identity/roles/overview', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListRoleOverviewResponseMock(),
      { status: 200
      })
  }, options)
}

export const getUpdateUserMockHandler = (overrideResponse?: User | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<User> | User), options?: RequestHandlerOptions) => {
  return http.patch('*/users/:id', async (info: Parameters<Parameters<typeof http.patch>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getUpdateUserResponseMock(),
      { status: 200
      })
  }, options)
}

export const getCreateBulkRegistrationMockHandler = (overrideResponse?: BulkRegistration | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<BulkRegistration> | BulkRegistration), options?: RequestHandlerOptions) => {
  return http.post('*/v1/devices/bulk-registrations', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getCreateBulkRegistrationResponseMock(),
      { status: 201
      })
  }, options)
}

export const getGetBulkRegistrationTemplateMockHandler = (overrideResponse?: ArrayBuffer | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ArrayBuffer> | ArrayBuffer), options?: RequestHandlerOptions) => {
  return http.get('*/v1/devices/bulk-registrations/template', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {

  const binaryBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetBulkRegistrationTemplateResponseMock();
    return HttpResponse.arrayBuffer(
      binaryBody instanceof ArrayBuffer
        ? binaryBody
        : new ArrayBuffer(0),
      { status: 200,
        headers: { 'Content-Type': 'application/octet-stream' }
      })
  }, options)
}

export const getGetBulkRegistrationMockHandler = (overrideResponse?: BulkRegistration | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<BulkRegistration> | BulkRegistration), options?: RequestHandlerOptions) => {
  return http.get('*/v1/devices/bulk-registrations/:bulkRegistrationId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetBulkRegistrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getStartBulkRegistrationMockHandler = (overrideResponse?: BulkRegistration | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<BulkRegistration> | BulkRegistration), options?: RequestHandlerOptions) => {
  return http.post('*/v1/devices/bulk-registrations/:bulkRegistrationId/start', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getStartBulkRegistrationResponseMock(),
      { status: 200
      })
  }, options)
}

export const getRetryBulkRegistrationBatchMockHandler = (overrideResponse?: BulkRegistration | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<BulkRegistration> | BulkRegistration), options?: RequestHandlerOptions) => {
  return http.post('*/v1/devices/bulk-registrations/:bulkRegistrationId/batches/:batchIndex/retry', async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getRetryBulkRegistrationBatchResponseMock(),
      { status: 202
      })
  }, options)
}

export const getGetBulkRegistrationResultsMockHandler = (overrideResponse?: ArrayBuffer | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ArrayBuffer> | ArrayBuffer), options?: RequestHandlerOptions) => {
  return http.get('*/v1/devices/bulk-registrations/:bulkRegistrationId/results', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {

  const binaryBody = overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetBulkRegistrationResultsResponseMock();
    return HttpResponse.arrayBuffer(
      binaryBody instanceof ArrayBuffer
        ? binaryBody
        : new ArrayBuffer(0),
      { status: 200,
        headers: { 'Content-Type': 'application/octet-stream' }
      })
  }, options)
}

export const getGetTenantBrandingMockHandler = (overrideResponse?: TenantBrandingResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<TenantBrandingResponse> | TenantBrandingResponse), options?: RequestHandlerOptions) => {
  return http.get('*/v1/tenants/me/branding', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetTenantBrandingResponseMock(),
      { status: 200
      })
  }, options)
}

export const getReplaceTenantBrandingMockHandler = (overrideResponse?: TenantBrandingResponse | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<TenantBrandingResponse> | TenantBrandingResponse), options?: RequestHandlerOptions) => {
  return http.put('*/v1/tenants/me/branding', async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getReplaceTenantBrandingResponseMock(),
      { status: 200
      })
  }, options)
}

export const getListTenantWhitelistsMockHandler = (overrideResponse?: TenantWhitelistsResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<TenantWhitelistsResponse> | TenantWhitelistsResponse), options?: RequestHandlerOptions) => {
  return http.get('*/v1/tenants/me/whitelists', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListTenantWhitelistsResponseMock(),
      { status: 200
      })
  }, options)
}
export const getCenorionAdminAPIPlaceholderMock = () => [
  getLoginMockHandler(),
  getRefreshSessionMockHandler(),
  getGetCurrentUserMockHandler(),
  getListUsersMockHandler(),
  getListDevicesMockHandler(),
  getRegisterDeviceMockHandler(),
  getGetDeviceMockHandler(),
  getLockDeviceMockHandler(),
  getUnlockDeviceMockHandler(),
  getCreateEnrolmentMockHandler(),
  getListIdentityUsersMockHandler(),
  getInviteUserMockHandler(),
  getGetIdentityUserMockHandler(),
  getDeactivateUserMockHandler(),
  getReactivateUserMockHandler(),
  getListRoleOverviewMockHandler(),
  getUpdateUserMockHandler(),
  getCreateBulkRegistrationMockHandler(),
  getGetBulkRegistrationTemplateMockHandler(),
  getGetBulkRegistrationMockHandler(),
  getStartBulkRegistrationMockHandler(),
  getRetryBulkRegistrationBatchMockHandler(),
  getGetBulkRegistrationResultsMockHandler(),
  getGetTenantBrandingMockHandler(),
  getReplaceTenantBrandingMockHandler(),
  getListTenantWhitelistsMockHandler()
]
